/* eslint-disable */
import { DateOnly } from 'src/utils/dates';
import { DateTime } from 'src/utils/dates';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: DateOnly;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: DateTime;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
};

export type Mutation = {
  __typename?: 'Mutation';
  /**  Creates an asset upload url with the following  key structure `assets/${UUID}`.  */
  createAssetUploadUrl: CreateAssetUploadUrlResult;
  saveConfiguration: SaveConfigurationResult;
  importConfiguration: EmptyResult;
  saveConfigurationToOption: SaveConfigurationToOptionResult;
  saveConfigurationToOptions: SaveConfigurationToOptionsResult;
  importConfigurationToOption: EmptyResult;
  saveElevation: SaveElevationResult;
  importElevation: EmptyResult;
  saveElevationStyle: SaveElevationStyleResult;
  importElevationStyle: EmptyResult;
  saveExteriorImage: SaveExteriorImageResult;
  importExteriorImage: EmptyResult;
  saveFloor: SaveFloorResult;
  importFloor: EmptyResult;
  importGSheetOptionPricing: Array<GSheetOptionPricing>;
  saveHelloWorld: SaveHelloWorldResult;
  saveHomeowner: SaveHomeownerResult;
  saveInteriorImage: SaveInteriorImageResult;
  importInteriorImage: EmptyResult;
  saveInternalUser: SaveInternalUserResult;
  saveOption: SaveOptionResult;
  importOption: EmptyResult;
  syncDeleteOptions: EmptyResult;
  saveOptionToOption: SaveOptionToOptionResult;
  importOptionToOption: EmptyResult;
  saveOptionToSpecLevel: SaveOptionToSpecLevelResult;
  importOptionToSpecLevel: EmptyResult;
  savePlan: SavePlanResult;
  importPlan: EmptyResult;
  importAll: EmptyResult;
  saveSpecLevel: SaveSpecLevelResult;
  importSpecLevel: EmptyResult;
  saveSpecLevelStyle: SaveSpecLevelStyleResult;
  importSpecLevelStyle: EmptyResult;
  saveUser: SaveUserResult;
  activateUser: ActivateUserResult;
  deactivateUser: DeactivateUserResult;
};


export type MutationCreateAssetUploadUrlArgs = {
  input: CreateAssetUploadUrlInput;
};


export type MutationSaveConfigurationArgs = {
  input: SaveConfigurationInput;
};


export type MutationSaveConfigurationToOptionArgs = {
  input: SaveConfigurationToOptionInput;
};


export type MutationSaveConfigurationToOptionsArgs = {
  input: SaveConfigurationToOptionsInput;
};


export type MutationSaveElevationArgs = {
  input: SaveElevationInput;
};


export type MutationSaveElevationStyleArgs = {
  input: SaveElevationStyleInput;
};


export type MutationSaveExteriorImageArgs = {
  input: SaveExteriorImageInput;
};


export type MutationSaveFloorArgs = {
  input: SaveFloorInput;
};


export type MutationSaveHelloWorldArgs = {
  input: SaveHelloWorldInput;
};


export type MutationSaveHomeownerArgs = {
  input: SaveHomeownerInput;
};


export type MutationSaveInteriorImageArgs = {
  input: SaveInteriorImageInput;
};


export type MutationSaveInternalUserArgs = {
  input: SaveInternalUserInput;
};


export type MutationSaveOptionArgs = {
  input: SaveOptionInput;
};


export type MutationSaveOptionToOptionArgs = {
  input: SaveOptionToOptionInput;
};


export type MutationSaveOptionToSpecLevelArgs = {
  input: SaveOptionToSpecLevelInput;
};


export type MutationSavePlanArgs = {
  input: SavePlanInput;
};


export type MutationSaveSpecLevelArgs = {
  input: SaveSpecLevelInput;
};


export type MutationSaveSpecLevelStyleArgs = {
  input: SaveSpecLevelStyleInput;
};


export type MutationSaveUserArgs = {
  input: SaveUserInput;
};


export type MutationActivateUserArgs = {
  input: ActivateUserInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};

export type Asset = {
  __typename?: 'Asset';
  id: Scalars['ID'];
  contentType: Scalars['String'];
  /**
   *   After the asset is uploaded, it can be downloaded from this URL.
   *
   * This is an S3 signed url, which means the user has already been authed when
   * creating the returned URL, and so can directly access this URL without any extra auth.
   * However, that also means this URL is unique per request (it has timestamps in it)
   * and so won't be cached.
   *
   * It expires after 1 week.
   */
  downloadUrl: Scalars['String'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String'];
  /**
   *   Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']>;
  /**
   *   Similar to downloadUrl, but is a consistent path like `/asset?id=assetId` so
   * that caching works.
   *
   * Note that auth will be done on access to `/asset` and so currently this only
   * works for internal users.
   */
  url: Scalars['String'];
  fileName?: Maybe<Scalars['String']>;
  sizeInBytes?: Maybe<Scalars['Int']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  version: Scalars['String'];
};


export type AssetPreviewUrlArgs = {
  resizing: AssetResizing;
};

export type CreateAssetUploadUrlInput = {
  contentType: Scalars['String'];
  previewResizing?: InputMaybe<AssetResizing>;
};

export type CreateAssetUploadUrlResult = {
  __typename?: 'CreateAssetUploadUrlResult';
  s3Key: Scalars['String'];
  uploadUrl: Scalars['String'];
  /** After the asset is uploaded, it can be viewed at this URL. */
  downloadUrl: Scalars['String'];
  /** Similar to downloadUrl, but has a content-disposition that will download the file immediately */
  attachmentUrl: Scalars['String'];
  /**
   *   Similar to downloadUrl, returns an S3 signed URL to a preview image resized as specified.
   * Only generated if previewResizing is provided as mutation input
   * Note that not all assets support previews, and this may return an undefined string
   */
  previewUrl?: Maybe<Scalars['String']>;
};

export type AssetResizing = {
  width?: InputMaybe<Scalars['Int']>;
  height?: InputMaybe<Scalars['Int']>;
  region?: InputMaybe<AssetResizingRegion>;
  /** Optional output image format, e.g. "jpg", "png", defaults to original asset format. */
  format?: InputMaybe<AssetResizingFormat>;
};

export enum AssetResizingFormat {
  Jpg = 'jpg',
  Png = 'png'
}

export enum AssetResizingRegion {
  Square = 'SQUARE',
  Full = 'FULL',
  Auto = 'AUTO'
}

export type AssetInput = {
  id?: InputMaybe<Scalars['ID']>;
  delete?: InputMaybe<Scalars['Boolean']>;
  /** This field is only accepted for Asset creation */
  contentType?: InputMaybe<Scalars['String']>;
  /** This field is accepted for Asset creation and update */
  fileName?: InputMaybe<Scalars['String']>;
  /** This field is only accepted for Asset creation */
  s3Key?: InputMaybe<Scalars['String']>;
  /** This field is only accepted for Asset creation */
  sizeInBytes?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  configuration: Configuration;
  options: Array<Option>;
  plans: Array<Plan>;
  /**  fuzzy search for properties matching address  */
  properties: Array<Property>;
  /**  property details  */
  property?: Maybe<Property>;
  testQuery: Scalars['Int'];
  specLevels: Array<SpecLevel>;
};


export type QueryConfigurationArgs = {
  code: Scalars['String'];
};


export type QueryOptionsArgs = {
  specLevelId: Scalars['ID'];
};


export type QueryPlansArgs = {
  filter: PlansFilter;
};


export type QueryPropertiesArgs = {
  address: Scalars['String'];
};


export type QueryPropertyArgs = {
  dpid: Scalars['ID'];
};


export type QueryTestQueryArgs = {
  error?: InputMaybe<Scalars['Boolean']>;
};


export type QuerySpecLevelsArgs = {
  elevationId: Scalars['ID'];
};

export type Configuration = {
  __typename?: 'Configuration';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  code: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevation: Elevation;
  elevationStyle: ElevationStyle;
  plan: Plan;
  specLevel: SpecLevel;
  specLevelStyle: SpecLevelStyle;
  toOptions: Array<ConfigurationToOption>;
  completedDate?: Maybe<Scalars['DateTime']>;
  address?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type SaveConfigurationInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['ID']>;
  elevationStyleId?: InputMaybe<Scalars['ID']>;
  planId?: InputMaybe<Scalars['ID']>;
  specLevelId?: InputMaybe<Scalars['ID']>;
  specLevelStyleId?: InputMaybe<Scalars['ID']>;
  completedDate?: InputMaybe<Scalars['DateTime']>;
  address?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type SaveConfigurationResult = {
  __typename?: 'SaveConfigurationResult';
  configuration: Configuration;
};

export type ConfigurationToOption = {
  __typename?: 'ConfigurationToOption';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  airtableId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  configuration: Configuration;
  option: Option;
};

export type SaveConfigurationToOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  configurationId?: InputMaybe<Scalars['ID']>;
  optionId?: InputMaybe<Scalars['ID']>;
};

export type SaveConfigurationToOptionResult = {
  __typename?: 'SaveConfigurationToOptionResult';
  configurationToOption: ConfigurationToOption;
};

export type SaveConfigurationToOptionsInput = {
  configurationToOptions: Array<SaveConfigurationToOptionInput>;
};

export type SaveConfigurationToOptionsResult = {
  __typename?: 'SaveConfigurationToOptionsResult';
  configurationToOptions: Array<ConfigurationToOption>;
};

export type Elevation = {
  __typename?: 'Elevation';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  plan: Plan;
  configurations: Array<Configuration>;
  styles: Array<ElevationStyle>;
  specLevels: Array<SpecLevel>;
};

export type SaveElevationInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  planId?: InputMaybe<Scalars['ID']>;
};

export type SaveElevationResult = {
  __typename?: 'SaveElevationResult';
  elevation: Elevation;
};

export type ElevationStyle = {
  __typename?: 'ElevationStyle';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevation: Elevation;
  configurations: Array<Configuration>;
  exteriorImages: Array<ExteriorImage>;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type SaveElevationStyleInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  elevationId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveElevationStyleResult = {
  __typename?: 'SaveElevationStyleResult';
  elevationStyle: ElevationStyle;
};

export enum LotType {
  Boyl = 'BOYL',
  Bool = 'BOOL'
}

export type LotTypeDetail = {
  __typename?: 'LotTypeDetail';
  code: LotType;
  name: Scalars['String'];
};

export enum UserType {
  Anonymous = 'ANONYMOUS',
  System = 'SYSTEM',
  Internal = 'INTERNAL',
  Homeowner = 'HOMEOWNER'
}

export type UserTypeDetail = {
  __typename?: 'UserTypeDetail';
  code: UserType;
  name: Scalars['String'];
};

export type ExteriorImage = {
  __typename?: 'ExteriorImage';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevationStyle: ElevationStyle;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type SaveExteriorImageInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  elevationStyleId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveExteriorImageResult = {
  __typename?: 'SaveExteriorImageResult';
  exteriorImage: ExteriorImage;
};

export type Floor = {
  __typename?: 'Floor';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  plan: Plan;
  options: Array<Option>;
};

export type SaveFloorInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  planId?: InputMaybe<Scalars['ID']>;
};

export type SaveFloorResult = {
  __typename?: 'SaveFloorResult';
  floor: Floor;
};

export type GSheetOptionPricing = {
  __typename?: 'GSheetOptionPricing';
  id: Scalars['ID'];
  price: Scalars['Int'];
};

export type HelloWorld = {
  __typename?: 'HelloWorld';
  id: Scalars['ID'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  isActive?: Maybe<Scalars['Boolean']>;
};

export type SaveHelloWorldInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
};

export type SaveHelloWorldResult = {
  __typename?: 'SaveHelloWorldResult';
  helloWorld: HelloWorld;
};

export type Homeowner = {
  __typename?: 'Homeowner';
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
  lastActive?: Maybe<Scalars['DateTime']>;
};

export type SaveHomeownerInput = {
  id?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
  lastActive?: InputMaybe<Scalars['DateTime']>;
};

export type SaveHomeownerResult = {
  __typename?: 'SaveHomeownerResult';
  homeowner: Homeowner;
};

export type InteriorImage = {
  __typename?: 'InteriorImage';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  specLevelStyle: SpecLevelStyle;
  sortOrder?: Maybe<Scalars['Int']>;
};

export type SaveInteriorImageInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  specLevelStyleId?: InputMaybe<Scalars['ID']>;
  sortOrder?: InputMaybe<Scalars['Int']>;
};

export type SaveInteriorImageResult = {
  __typename?: 'SaveInteriorImageResult';
  interiorImage: InteriorImage;
};

export type InternalUser = {
  __typename?: 'InternalUser';
  id: Scalars['ID'];
  name: Scalars['String'];
  avatarUrl: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  user: User;
};

export type SaveInternalUserInput = {
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  avatarUrl?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['ID']>;
};

export type SaveInternalUserResult = {
  __typename?: 'SaveInternalUserResult';
  internalUser: InternalUser;
};

export type Option = {
  __typename?: 'Option';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  optionCode: Scalars['String'];
  bedrooms: Scalars['String'];
  bathrooms: Scalars['String'];
  garageParking: Scalars['String'];
  sqft: Scalars['String'];
  image?: Maybe<Scalars['String']>;
  location: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  floor?: Maybe<Floor>;
  /**  computed field calc'd from m2m option_to_spec_level lookup  */
  priceInCents: Scalars['Int'];
  /**  computed field calc'd from location  */
  group: Scalars['String'];
  configurationTos: Array<ConfigurationToOption>;
  conflictOptionToOptions: Array<OptionToOption>;
  optionToOptions: Array<OptionToOption>;
  toSpecLevels: Array<OptionToSpecLevel>;
  /**  minimum sqft option adds to plan  */
  baseSqft: Scalars['Int'];
  floorPlanImage?: Maybe<Scalars['String']>;
};


export type OptionPriceInCentsArgs = {
  specLevelId: Scalars['ID'];
};

export type SaveOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  optionCode?: InputMaybe<Scalars['String']>;
  bedrooms?: InputMaybe<Scalars['String']>;
  bathrooms?: InputMaybe<Scalars['String']>;
  garageParking?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  floorId?: InputMaybe<Scalars['ID']>;
  baseSqft?: InputMaybe<Scalars['Int']>;
  floorPlanImage?: InputMaybe<Scalars['String']>;
};

export type SaveOptionResult = {
  __typename?: 'SaveOptionResult';
  option: Option;
};

export type OptionToOption = {
  __typename?: 'OptionToOption';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  conflictOption: Option;
  option: Option;
};

export type SaveOptionToOptionInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  conflictOptionId?: InputMaybe<Scalars['ID']>;
  optionId?: InputMaybe<Scalars['ID']>;
};

export type SaveOptionToOptionResult = {
  __typename?: 'SaveOptionToOptionResult';
  optionToOption: OptionToOption;
};

export type OptionToSpecLevel = {
  __typename?: 'OptionToSpecLevel';
  id: Scalars['ID'];
  createdAt: Scalars['DateTime'];
  airtableId: Scalars['String'];
  priceInCents: Scalars['Int'];
  updatedAt: Scalars['DateTime'];
  option: Option;
  specLevel: SpecLevel;
};

export type SaveOptionToSpecLevelInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  optionId?: InputMaybe<Scalars['ID']>;
  specLevelId?: InputMaybe<Scalars['ID']>;
};

export type SaveOptionToSpecLevelResult = {
  __typename?: 'SaveOptionToSpecLevelResult';
  optionToSpecLevel: OptionToSpecLevel;
};

export type Plan = {
  __typename?: 'Plan';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  priceInCents: Scalars['Int'];
  bedrooms?: Maybe<Scalars['String']>;
  bathrooms?: Maybe<Scalars['String']>;
  garageParking?: Maybe<Scalars['String']>;
  sqft?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  configurations: Array<Configuration>;
  elevations: Array<Elevation>;
  floors: Array<Floor>;
  /**  sqft of plan with no options  */
  baseSqft: Scalars['Int'];
};

export type SavePlanInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  bedrooms?: InputMaybe<Scalars['String']>;
  bathrooms?: InputMaybe<Scalars['String']>;
  garageParking?: InputMaybe<Scalars['String']>;
  sqft?: InputMaybe<Scalars['String']>;
  baseSqft?: InputMaybe<Scalars['Int']>;
};

export type SavePlanResult = {
  __typename?: 'SavePlanResult';
  plan: Plan;
};

export type PlansFilter = {
  id?: InputMaybe<Array<Scalars['ID']>>;
};

export type Property = {
  __typename?: 'Property';
  dpid: Scalars['ID'];
  fullStreetAddress: Scalars['String'];
  cityName: Scalars['String'];
  state: Scalars['String'];
  zipCode: Scalars['String'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  unitNumber?: Maybe<Scalars['String']>;
  propertyTypeSimple?: Maybe<Scalars['String']>;
  lotSize?: Maybe<Scalars['Int']>;
  yearBuiltOrRenovated?: Maybe<Scalars['String']>;
  finishedSqft?: Maybe<Scalars['Int']>;
  totalSqft?: Maybe<Scalars['Int']>;
  numBedrooms?: Maybe<Scalars['Float']>;
  numBaths?: Maybe<Scalars['Float']>;
  numStories?: Maybe<Scalars['Float']>;
  hasPool?: Maybe<Scalars['Boolean']>;
  garageNumCars?: Maybe<Scalars['Int']>;
  buildableSqft?: Maybe<Scalars['Float']>;
  lotFrontageFeet?: Maybe<Scalars['Int']>;
  lotDepthFeet?: Maybe<Scalars['Int']>;
  zoning?: Maybe<Scalars['String']>;
};

export enum Order {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum DateOperation {
  Before = 'BEFORE',
  On = 'ON',
  After = 'AFTER',
  Between = 'BETWEEN'
}

export type Url = {
  __typename?: 'Url';
  /** Absolute path of the url, e.g. `/thing/a:123/` */
  path: Scalars['String'];
  /** Fully qualified http url, e.g. `https://checkout.homebound.com/thing/a:123/` */
  url: Scalars['String'];
};

/**
 * Represents both whether an operation is performable, and if not the reasons.
 * When the reason relates to a specific entity, we return it for convenient UI navigation.
 */
export type PotentialOperation = {
  __typename?: 'PotentialOperation';
  allowed: Scalars['Boolean'];
  disabledReasons: Array<Reason>;
};

export type Reason = {
  __typename?: 'Reason';
  message: Scalars['String'];
};

export type UserError = {
  __typename?: 'UserError';
  message: Scalars['String'];
};

/** A standard result for when we're not returning any user errors, and instead will just fail the request */
export type EmptyResult = {
  __typename?: 'EmptyResult';
  emptyResult?: Maybe<Scalars['String']>;
};

/** Generic bulk delete input type */
export type DeleteEntitiesInput = {
  id: Array<Scalars['ID']>;
};

/** Generic delete input type */
export type DeleteEntityInput = {
  id: Scalars['ID'];
};

export type History = {
  __typename?: 'History';
  recordedAt: Scalars['DateTime'];
  avatar: Scalars['String'];
  title: Scalars['String'];
  subtitle?: Maybe<Scalars['String']>;
};

export type SpecLevel = {
  __typename?: 'SpecLevel';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  elevation: Elevation;
  configurations: Array<Configuration>;
  optionTos: Array<OptionToSpecLevel>;
  styles: Array<SpecLevelStyle>;
};

export type SaveSpecLevelInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  elevationId?: InputMaybe<Scalars['ID']>;
};

export type SaveSpecLevelResult = {
  __typename?: 'SaveSpecLevelResult';
  specLevel: SpecLevel;
};

export type SpecLevelStyle = {
  __typename?: 'SpecLevelStyle';
  id: Scalars['ID'];
  airtableId: Scalars['String'];
  name: Scalars['String'];
  priceInCents: Scalars['Int'];
  image?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  specLevel: SpecLevel;
  configurations: Array<Configuration>;
  interiorImages: Array<InteriorImage>;
};

export type SaveSpecLevelStyleInput = {
  id?: InputMaybe<Scalars['ID']>;
  airtableId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  priceInCents?: InputMaybe<Scalars['Int']>;
  image?: InputMaybe<Scalars['String']>;
  specLevelId?: InputMaybe<Scalars['ID']>;
};

export type SaveSpecLevelStyleResult = {
  __typename?: 'SaveSpecLevelStyleResult';
  specLevelStyle: SpecLevelStyle;
};

export type User = {
  __typename?: 'User';
  /** Note ID is not required because a system user would not have it. */
  id?: Maybe<Scalars['ID']>;
  email: Scalars['String'];
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  gsuiteEmailAlias?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  updatedAt: Scalars['DateTime'];
  type: UserTypeDetail;
  homeowner?: Maybe<Homeowner>;
  internalUser?: Maybe<InternalUser>;
  isActive?: Maybe<Scalars['Boolean']>;
};

export type SaveUserInput = {
  id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  deactivatedAt?: InputMaybe<Scalars['DateTime']>;
  gsuiteEmailAlias?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<UserType>;
  internalUserId?: InputMaybe<Scalars['ID']>;
};

export type SaveUserResult = {
  __typename?: 'SaveUserResult';
  userErrors: Array<UserError>;
};

export type DeactivateUserInput = {
  email: Scalars['String'];
};

export type DeactivateUserResult = {
  __typename?: 'DeactivateUserResult';
  userErrors: Array<UserError>;
};

export type ActivateUserInput = {
  email: Scalars['String'];
};

export type ActivateUserResult = {
  __typename?: 'ActivateUserResult';
  userErrors: Array<UserError>;
};

export type PlansQueryVariables = Exact<{ [key: string]: never; }>;


export type PlansQuery = { __typename?: 'Query', plans: Array<{ __typename?: 'Plan', id: string, name: string, description?: string | null | undefined, priceInCents: number, bedrooms?: string | null | undefined, bathrooms?: string | null | undefined, garageParking?: string | null | undefined, sqft?: string | null | undefined, baseSqft: number, elevations: Array<{ __typename?: 'Elevation', id: string, name: string, priceInCents: number, styles: Array<{ __typename?: 'ElevationStyle', id: string, name: string, priceInCents: number, image?: string | null | undefined, exteriorImages: Array<{ __typename?: 'ExteriorImage', id: string, image?: string | null | undefined }> }> }>, floors: Array<{ __typename?: 'Floor', id: string, name: string, image?: string | null | undefined }> }> };

export type PlanFragment = { __typename?: 'Plan', id: string, name: string, description?: string | null | undefined, priceInCents: number, bedrooms?: string | null | undefined, bathrooms?: string | null | undefined, garageParking?: string | null | undefined, sqft?: string | null | undefined, baseSqft: number, elevations: Array<{ __typename?: 'Elevation', id: string, name: string, priceInCents: number, styles: Array<{ __typename?: 'ElevationStyle', id: string, name: string, priceInCents: number, image?: string | null | undefined, exteriorImages: Array<{ __typename?: 'ExteriorImage', id: string, image?: string | null | undefined }> }> }>, floors: Array<{ __typename?: 'Floor', id: string, name: string, image?: string | null | undefined }> };

export type ElevationFragment = { __typename?: 'Elevation', id: string, name: string, priceInCents: number, styles: Array<{ __typename?: 'ElevationStyle', id: string, name: string, priceInCents: number, image?: string | null | undefined, exteriorImages: Array<{ __typename?: 'ExteriorImage', id: string, image?: string | null | undefined }> }> };

export type ElevationStyleFragment = { __typename?: 'ElevationStyle', id: string, name: string, priceInCents: number, image?: string | null | undefined, exteriorImages: Array<{ __typename?: 'ExteriorImage', id: string, image?: string | null | undefined }> };

export type ExteriorImageFragment = { __typename?: 'ExteriorImage', id: string, image?: string | null | undefined };

export type FloorFragment = { __typename?: 'Floor', id: string, name: string, image?: string | null | undefined };

export type SpecLevelsQueryVariables = Exact<{
  elevationId: Scalars['ID'];
}>;


export type SpecLevelsQuery = { __typename?: 'Query', specLevels: Array<{ __typename?: 'SpecLevel', id: string, name: string, priceInCents: number, styles: Array<{ __typename?: 'SpecLevelStyle', id: string, name: string, priceInCents: number, interiorImages: Array<{ __typename?: 'InteriorImage', id: string, name: string, image?: string | null | undefined }> }> }> };

export type SpecLevelFragment = { __typename?: 'SpecLevel', id: string, name: string, priceInCents: number, styles: Array<{ __typename?: 'SpecLevelStyle', id: string, name: string, priceInCents: number, interiorImages: Array<{ __typename?: 'InteriorImage', id: string, name: string, image?: string | null | undefined }> }> };

export type SpecLevelStyleFragment = { __typename?: 'SpecLevelStyle', id: string, name: string, priceInCents: number, interiorImages: Array<{ __typename?: 'InteriorImage', id: string, name: string, image?: string | null | undefined }> };

export type InteriorImageFragment = { __typename?: 'InteriorImage', id: string, name: string, image?: string | null | undefined };

export type SaveConfigurationMutationVariables = Exact<{
  input: SaveConfigurationInput;
}>;


export type SaveConfigurationMutation = { __typename?: 'Mutation', saveConfiguration: { __typename?: 'SaveConfigurationResult', configuration: { __typename?: 'Configuration', id: string, code: string, airtableId: string } } };

export type SaveConfigurationOptionsMutationVariables = Exact<{
  input: SaveConfigurationToOptionsInput;
}>;


export type SaveConfigurationOptionsMutation = { __typename?: 'Mutation', saveConfigurationToOptions: { __typename?: 'SaveConfigurationToOptionsResult', configurationToOptions: Array<{ __typename?: 'ConfigurationToOption', id: string }> } };

export type ConfigurationQueryVariables = Exact<{
  code: Scalars['String'];
}>;


export type ConfigurationQuery = { __typename?: 'Query', configuration: { __typename?: 'Configuration', id: string, code: string, createdAt: DateTime, plan: { __typename?: 'Plan', id: string, name: string, description?: string | null | undefined, priceInCents: number, bedrooms?: string | null | undefined, bathrooms?: string | null | undefined, garageParking?: string | null | undefined, sqft?: string | null | undefined, baseSqft: number, elevations: Array<{ __typename?: 'Elevation', id: string, name: string, priceInCents: number, styles: Array<{ __typename?: 'ElevationStyle', id: string, name: string, priceInCents: number, image?: string | null | undefined, exteriorImages: Array<{ __typename?: 'ExteriorImage', id: string, image?: string | null | undefined }> }> }>, floors: Array<{ __typename?: 'Floor', id: string, name: string, image?: string | null | undefined }> }, elevation: { __typename?: 'Elevation', id: string, name: string, priceInCents: number, styles: Array<{ __typename?: 'ElevationStyle', id: string, name: string, priceInCents: number, image?: string | null | undefined, exteriorImages: Array<{ __typename?: 'ExteriorImage', id: string, image?: string | null | undefined }> }> }, elevationStyle: { __typename?: 'ElevationStyle', id: string, name: string, priceInCents: number, image?: string | null | undefined, exteriorImages: Array<{ __typename?: 'ExteriorImage', id: string, image?: string | null | undefined }> }, specLevel: { __typename?: 'SpecLevel', id: string, name: string, priceInCents: number, styles: Array<{ __typename?: 'SpecLevelStyle', id: string, name: string, priceInCents: number, interiorImages: Array<{ __typename?: 'InteriorImage', id: string, name: string, image?: string | null | undefined }> }> }, specLevelStyle: { __typename?: 'SpecLevelStyle', id: string, name: string, priceInCents: number, interiorImages: Array<{ __typename?: 'InteriorImage', id: string, name: string, image?: string | null | undefined }> }, toOptions: Array<{ __typename?: 'ConfigurationToOption', id: string, option: { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, location: string, group: string, baseSqft: number, bedrooms: string, bathrooms: string, garageParking: string, floor?: { __typename?: 'Floor', id: string, name: string, image?: string | null | undefined } | null | undefined, toSpecLevels: Array<{ __typename?: 'OptionToSpecLevel', id: string, priceInCents: number, specLevel: { __typename?: 'SpecLevel', id: string } }> } }> } };

export type PropertiesQueryVariables = Exact<{
  address: Scalars['String'];
}>;


export type PropertiesQuery = { __typename?: 'Query', properties: Array<{ __typename?: 'Property', dpid: string, fullStreetAddress: string, cityName: string, state: string, zipCode: string }> };

export type PropertyQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PropertyQuery = { __typename?: 'Query', property?: { __typename?: 'Property', latitude: number, longitude: number, lotSize?: number | null | undefined, buildableSqft?: number | null | undefined, lotFrontageFeet?: number | null | undefined, lotDepthFeet?: number | null | undefined, dpid: string, fullStreetAddress: string, cityName: string, state: string, zipCode: string } | null | undefined };

export type PropertyAddressFragment = { __typename?: 'Property', dpid: string, fullStreetAddress: string, cityName: string, state: string, zipCode: string };

export type PropertyFragment = { __typename?: 'Property', latitude: number, longitude: number, lotSize?: number | null | undefined, buildableSqft?: number | null | undefined, lotFrontageFeet?: number | null | undefined, lotDepthFeet?: number | null | undefined, dpid: string, fullStreetAddress: string, cityName: string, state: string, zipCode: string };

export type OptionsQueryVariables = Exact<{
  specLevelId: Scalars['ID'];
}>;


export type OptionsQuery = { __typename?: 'Query', options: Array<{ __typename?: 'Option', id: string, name: string, description?: string | null | undefined, location: string, group: string, image?: string | null | undefined, floorPlanImage?: string | null | undefined, baseSqft: number, bedrooms: string, bathrooms: string, garageParking: string, priceInCents: number, floor?: { __typename?: 'Floor', id: string, name: string, image?: string | null | undefined } | null | undefined, optionToOptions: Array<{ __typename?: 'OptionToOption', id: string, conflictOption: { __typename?: 'Option', id: string, name: string } }> }> };

export type OptionFragment = { __typename?: 'Option', id: string, name: string, description?: string | null | undefined, location: string, group: string, image?: string | null | undefined, floorPlanImage?: string | null | undefined, baseSqft: number, bedrooms: string, bathrooms: string, garageParking: string, priceInCents: number, floor?: { __typename?: 'Floor', id: string, name: string, image?: string | null | undefined } | null | undefined, optionToOptions: Array<{ __typename?: 'OptionToOption', id: string, conflictOption: { __typename?: 'Option', id: string, name: string } }> };

export type OptionConflictFragment = { __typename?: 'OptionToOption', id: string, conflictOption: { __typename?: 'Option', id: string, name: string } };

export const ExteriorImageFragmentDoc = gql`
    fragment ExteriorImage on ExteriorImage {
  id
  image
}
    `;
export const ElevationStyleFragmentDoc = gql`
    fragment ElevationStyle on ElevationStyle {
  id
  name
  priceInCents
  image
  exteriorImages {
    ...ExteriorImage
  }
}
    ${ExteriorImageFragmentDoc}`;
export const ElevationFragmentDoc = gql`
    fragment Elevation on Elevation {
  id
  name
  priceInCents
  styles {
    ...ElevationStyle
  }
}
    ${ElevationStyleFragmentDoc}`;
export const FloorFragmentDoc = gql`
    fragment Floor on Floor {
  id
  name
  image
}
    `;
export const PlanFragmentDoc = gql`
    fragment Plan on Plan {
  id
  name
  description
  priceInCents
  bedrooms
  bathrooms
  garageParking
  sqft
  baseSqft
  elevations {
    ...Elevation
  }
  floors {
    ...Floor
  }
}
    ${ElevationFragmentDoc}
${FloorFragmentDoc}`;
export const InteriorImageFragmentDoc = gql`
    fragment InteriorImage on InteriorImage {
  id
  name
  image
}
    `;
export const SpecLevelStyleFragmentDoc = gql`
    fragment SpecLevelStyle on SpecLevelStyle {
  id
  name
  priceInCents
  interiorImages {
    ...InteriorImage
  }
}
    ${InteriorImageFragmentDoc}`;
export const SpecLevelFragmentDoc = gql`
    fragment SpecLevel on SpecLevel {
  id
  name
  priceInCents
  styles {
    ...SpecLevelStyle
  }
}
    ${SpecLevelStyleFragmentDoc}`;
export const PropertyAddressFragmentDoc = gql`
    fragment PropertyAddress on Property {
  dpid
  fullStreetAddress
  cityName
  state
  zipCode
}
    `;
export const PropertyFragmentDoc = gql`
    fragment Property on Property {
  ...PropertyAddress
  latitude
  longitude
  lotSize
  buildableSqft
  lotFrontageFeet
  lotDepthFeet
}
    ${PropertyAddressFragmentDoc}`;
export const OptionConflictFragmentDoc = gql`
    fragment OptionConflict on OptionToOption {
  id
  conflictOption {
    id
    name
  }
}
    `;
export const OptionFragmentDoc = gql`
    fragment Option on Option {
  id
  name
  description
  location
  group
  image
  floorPlanImage
  baseSqft
  bedrooms
  bathrooms
  garageParking
  floor {
    ...Floor
  }
  priceInCents(specLevelId: $specLevelId)
  optionToOptions {
    ...OptionConflict
  }
}
    ${FloorFragmentDoc}
${OptionConflictFragmentDoc}`;
export const PlansDocument = gql`
    query Plans {
  plans(filter: {}) {
    ...Plan
  }
}
    ${PlanFragmentDoc}`;

/**
 * __usePlansQuery__
 *
 * To run a query within a React component, call `usePlansQuery` and pass it any options that fit your needs.
 * When your component renders, `usePlansQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePlansQuery({
 *   variables: {
 *   },
 * });
 */
export function usePlansQuery(baseOptions?: Apollo.QueryHookOptions<PlansQuery, PlansQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
      }
export function usePlansLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PlansQuery, PlansQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PlansQuery, PlansQueryVariables>(PlansDocument, options);
        }
export type PlansQueryHookResult = ReturnType<typeof usePlansQuery>;
export type PlansLazyQueryHookResult = ReturnType<typeof usePlansLazyQuery>;
export type PlansQueryResult = Apollo.QueryResult<PlansQuery, PlansQueryVariables>;
export const SpecLevelsDocument = gql`
    query SpecLevels($elevationId: ID!) {
  specLevels(elevationId: $elevationId) {
    ...SpecLevel
  }
}
    ${SpecLevelFragmentDoc}`;

/**
 * __useSpecLevelsQuery__
 *
 * To run a query within a React component, call `useSpecLevelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSpecLevelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSpecLevelsQuery({
 *   variables: {
 *      elevationId: // value for 'elevationId'
 *   },
 * });
 */
export function useSpecLevelsQuery(baseOptions: Apollo.QueryHookOptions<SpecLevelsQuery, SpecLevelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SpecLevelsQuery, SpecLevelsQueryVariables>(SpecLevelsDocument, options);
      }
export function useSpecLevelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SpecLevelsQuery, SpecLevelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SpecLevelsQuery, SpecLevelsQueryVariables>(SpecLevelsDocument, options);
        }
export type SpecLevelsQueryHookResult = ReturnType<typeof useSpecLevelsQuery>;
export type SpecLevelsLazyQueryHookResult = ReturnType<typeof useSpecLevelsLazyQuery>;
export type SpecLevelsQueryResult = Apollo.QueryResult<SpecLevelsQuery, SpecLevelsQueryVariables>;
export const SaveConfigurationDocument = gql`
    mutation SaveConfiguration($input: SaveConfigurationInput!) {
  saveConfiguration(input: $input) {
    configuration {
      id
      code
      airtableId
    }
  }
}
    `;
export type SaveConfigurationMutationFn = Apollo.MutationFunction<SaveConfigurationMutation, SaveConfigurationMutationVariables>;

/**
 * __useSaveConfigurationMutation__
 *
 * To run a mutation, you first call `useSaveConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConfigurationMutation, { data, loading, error }] = useSaveConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveConfigurationMutation(baseOptions?: Apollo.MutationHookOptions<SaveConfigurationMutation, SaveConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConfigurationMutation, SaveConfigurationMutationVariables>(SaveConfigurationDocument, options);
      }
export type SaveConfigurationMutationHookResult = ReturnType<typeof useSaveConfigurationMutation>;
export type SaveConfigurationMutationResult = Apollo.MutationResult<SaveConfigurationMutation>;
export type SaveConfigurationMutationOptions = Apollo.BaseMutationOptions<SaveConfigurationMutation, SaveConfigurationMutationVariables>;
export const SaveConfigurationOptionsDocument = gql`
    mutation SaveConfigurationOptions($input: SaveConfigurationToOptionsInput!) {
  saveConfigurationToOptions(input: $input) {
    configurationToOptions {
      id
    }
  }
}
    `;
export type SaveConfigurationOptionsMutationFn = Apollo.MutationFunction<SaveConfigurationOptionsMutation, SaveConfigurationOptionsMutationVariables>;

/**
 * __useSaveConfigurationOptionsMutation__
 *
 * To run a mutation, you first call `useSaveConfigurationOptionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConfigurationOptionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConfigurationOptionsMutation, { data, loading, error }] = useSaveConfigurationOptionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveConfigurationOptionsMutation(baseOptions?: Apollo.MutationHookOptions<SaveConfigurationOptionsMutation, SaveConfigurationOptionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConfigurationOptionsMutation, SaveConfigurationOptionsMutationVariables>(SaveConfigurationOptionsDocument, options);
      }
export type SaveConfigurationOptionsMutationHookResult = ReturnType<typeof useSaveConfigurationOptionsMutation>;
export type SaveConfigurationOptionsMutationResult = Apollo.MutationResult<SaveConfigurationOptionsMutation>;
export type SaveConfigurationOptionsMutationOptions = Apollo.BaseMutationOptions<SaveConfigurationOptionsMutation, SaveConfigurationOptionsMutationVariables>;
export const ConfigurationDocument = gql`
    query Configuration($code: String!) {
  configuration(code: $code) {
    id
    code
    createdAt
    plan {
      ...Plan
    }
    elevation {
      ...Elevation
    }
    elevationStyle {
      ...ElevationStyle
    }
    specLevel {
      ...SpecLevel
    }
    specLevelStyle {
      ...SpecLevelStyle
    }
    toOptions {
      id
      option {
        id
        name
        description
        location
        group
        baseSqft
        bedrooms
        bathrooms
        garageParking
        floor {
          ...Floor
        }
        toSpecLevels {
          id
          priceInCents
          specLevel {
            id
          }
        }
      }
    }
  }
}
    ${PlanFragmentDoc}
${ElevationFragmentDoc}
${ElevationStyleFragmentDoc}
${SpecLevelFragmentDoc}
${SpecLevelStyleFragmentDoc}
${FloorFragmentDoc}`;

/**
 * __useConfigurationQuery__
 *
 * To run a query within a React component, call `useConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useConfigurationQuery({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useConfigurationQuery(baseOptions: Apollo.QueryHookOptions<ConfigurationQuery, ConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ConfigurationQuery, ConfigurationQueryVariables>(ConfigurationDocument, options);
      }
export function useConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ConfigurationQuery, ConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ConfigurationQuery, ConfigurationQueryVariables>(ConfigurationDocument, options);
        }
export type ConfigurationQueryHookResult = ReturnType<typeof useConfigurationQuery>;
export type ConfigurationLazyQueryHookResult = ReturnType<typeof useConfigurationLazyQuery>;
export type ConfigurationQueryResult = Apollo.QueryResult<ConfigurationQuery, ConfigurationQueryVariables>;
export const PropertiesDocument = gql`
    query Properties($address: String!) {
  properties(address: $address) {
    ...PropertyAddress
  }
}
    ${PropertyAddressFragmentDoc}`;

/**
 * __usePropertiesQuery__
 *
 * To run a query within a React component, call `usePropertiesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertiesQuery({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function usePropertiesQuery(baseOptions: Apollo.QueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
      }
export function usePropertiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertiesQuery, PropertiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertiesQuery, PropertiesQueryVariables>(PropertiesDocument, options);
        }
export type PropertiesQueryHookResult = ReturnType<typeof usePropertiesQuery>;
export type PropertiesLazyQueryHookResult = ReturnType<typeof usePropertiesLazyQuery>;
export type PropertiesQueryResult = Apollo.QueryResult<PropertiesQuery, PropertiesQueryVariables>;
export const PropertyDocument = gql`
    query Property($id: ID!) {
  property(dpid: $id) {
    ...Property
  }
}
    ${PropertyFragmentDoc}`;

/**
 * __usePropertyQuery__
 *
 * To run a query within a React component, call `usePropertyQuery` and pass it any options that fit your needs.
 * When your component renders, `usePropertyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePropertyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePropertyQuery(baseOptions: Apollo.QueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
      }
export function usePropertyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PropertyQuery, PropertyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PropertyQuery, PropertyQueryVariables>(PropertyDocument, options);
        }
export type PropertyQueryHookResult = ReturnType<typeof usePropertyQuery>;
export type PropertyLazyQueryHookResult = ReturnType<typeof usePropertyLazyQuery>;
export type PropertyQueryResult = Apollo.QueryResult<PropertyQuery, PropertyQueryVariables>;
export const OptionsDocument = gql`
    query Options($specLevelId: ID!) {
  options(specLevelId: $specLevelId) {
    ...Option
  }
}
    ${OptionFragmentDoc}`;

/**
 * __useOptionsQuery__
 *
 * To run a query within a React component, call `useOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOptionsQuery({
 *   variables: {
 *      specLevelId: // value for 'specLevelId'
 *   },
 * });
 */
export function useOptionsQuery(baseOptions: Apollo.QueryHookOptions<OptionsQuery, OptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OptionsQuery, OptionsQueryVariables>(OptionsDocument, options);
      }
export function useOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OptionsQuery, OptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OptionsQuery, OptionsQueryVariables>(OptionsDocument, options);
        }
export type OptionsQueryHookResult = ReturnType<typeof useOptionsQuery>;
export type OptionsLazyQueryHookResult = ReturnType<typeof useOptionsLazyQuery>;
export type OptionsQueryResult = Apollo.QueryResult<OptionsQuery, OptionsQueryVariables>;
import { newDateTime } from "src/utils/tests/testDates";

const factories: Record<string, Function> = {};
export interface AssetOptions {
  __typename?: "Asset";
  id?: Asset["id"];
  contentType?: Asset["contentType"];
  downloadUrl?: Asset["downloadUrl"];
  attachmentUrl?: Asset["attachmentUrl"];
  previewUrl?: Asset["previewUrl"];
  url?: Asset["url"];
  fileName?: Asset["fileName"];
  sizeInBytes?: Asset["sizeInBytes"];
  createdAt?: Asset["createdAt"];
  updatedAt?: Asset["updatedAt"];
  version?: Asset["version"];
}

export function newAsset(options: AssetOptions = {}, cache: Record<string, any> = {}): Asset {
  const o = (options.__typename ? options : cache["Asset"] = {}) as Asset;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Asset";
  o.id = options.id ?? nextFactoryId("Asset");
  o.contentType = options.contentType ?? "contentType";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  o.url = options.url ?? "url";
  o.fileName = options.fileName ?? null;
  o.sizeInBytes = options.sizeInBytes ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.version = options.version ?? "version";
  return o;
}

factories["Asset"] = newAsset;

function maybeNewAsset(value: AssetOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Asset {
  if (value === undefined) {
    return isSet ? undefined : cache["Asset"] || newAsset({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newAsset(value, cache);
  }
}

function maybeNewOrNullAsset(value: AssetOptions | undefined | null, cache: Record<string, any>): Asset | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newAsset(value, cache);
  }
}
export interface CreateAssetUploadUrlResultOptions {
  __typename?: "CreateAssetUploadUrlResult";
  s3Key?: CreateAssetUploadUrlResult["s3Key"];
  uploadUrl?: CreateAssetUploadUrlResult["uploadUrl"];
  downloadUrl?: CreateAssetUploadUrlResult["downloadUrl"];
  attachmentUrl?: CreateAssetUploadUrlResult["attachmentUrl"];
  previewUrl?: CreateAssetUploadUrlResult["previewUrl"];
}

export function newCreateAssetUploadUrlResult(
  options: CreateAssetUploadUrlResultOptions = {},
  cache: Record<string, any> = {},
): CreateAssetUploadUrlResult {
  const o = (options.__typename ? options : cache["CreateAssetUploadUrlResult"] = {}) as CreateAssetUploadUrlResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "CreateAssetUploadUrlResult";
  o.s3Key = options.s3Key ?? "s3Key";
  o.uploadUrl = options.uploadUrl ?? "uploadUrl";
  o.downloadUrl = options.downloadUrl ?? "downloadUrl";
  o.attachmentUrl = options.attachmentUrl ?? "attachmentUrl";
  o.previewUrl = options.previewUrl ?? null;
  return o;
}

factories["CreateAssetUploadUrlResult"] = newCreateAssetUploadUrlResult;

function maybeNewCreateAssetUploadUrlResult(
  value: CreateAssetUploadUrlResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): CreateAssetUploadUrlResult {
  if (value === undefined) {
    return isSet ? undefined : cache["CreateAssetUploadUrlResult"] || newCreateAssetUploadUrlResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCreateAssetUploadUrlResult(value, cache);
  }
}

function maybeNewOrNullCreateAssetUploadUrlResult(
  value: CreateAssetUploadUrlResultOptions | undefined | null,
  cache: Record<string, any>,
): CreateAssetUploadUrlResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newCreateAssetUploadUrlResult(value, cache);
  }
}
export interface ConfigurationOptions {
  __typename?: "Configuration";
  id?: Configuration["id"];
  airtableId?: Configuration["airtableId"];
  code?: Configuration["code"];
  name?: Configuration["name"];
  email?: Configuration["email"];
  createdAt?: Configuration["createdAt"];
  updatedAt?: Configuration["updatedAt"];
  elevation?: ElevationOptions;
  elevationStyle?: ElevationStyleOptions;
  plan?: PlanOptions;
  specLevel?: SpecLevelOptions;
  specLevelStyle?: SpecLevelStyleOptions;
  toOptions?: Array<ConfigurationToOptionOptions>;
  completedDate?: Configuration["completedDate"];
  address?: Configuration["address"];
  phoneNumber?: Configuration["phoneNumber"];
}

export function newConfiguration(options: ConfigurationOptions = {}, cache: Record<string, any> = {}): Configuration {
  const o = (options.__typename ? options : cache["Configuration"] = {}) as Configuration;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Configuration";
  o.id = options.id ?? nextFactoryId("Configuration");
  o.airtableId = options.airtableId ?? "airtableId";
  o.code = options.code ?? "code";
  o.name = options.name ?? null;
  o.email = options.email ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevation = maybeNewElevation(options.elevation, cache, options.hasOwnProperty("elevation"));
  o.elevationStyle = maybeNewElevationStyle(options.elevationStyle, cache, options.hasOwnProperty("elevationStyle"));
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  o.specLevel = maybeNewSpecLevel(options.specLevel, cache, options.hasOwnProperty("specLevel"));
  o.specLevelStyle = maybeNewSpecLevelStyle(options.specLevelStyle, cache, options.hasOwnProperty("specLevelStyle"));
  o.toOptions = (options.toOptions ?? []).map((i) =>
    maybeNewConfigurationToOption(i, cache, options.hasOwnProperty("toOptions"))
  );
  o.completedDate = options.completedDate ?? null;
  o.address = options.address ?? null;
  o.phoneNumber = options.phoneNumber ?? null;
  return o;
}

factories["Configuration"] = newConfiguration;

function maybeNewConfiguration(
  value: ConfigurationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Configuration {
  if (value === undefined) {
    return isSet ? undefined : cache["Configuration"] || newConfiguration({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newConfiguration(value, cache);
  }
}

function maybeNewOrNullConfiguration(
  value: ConfigurationOptions | undefined | null,
  cache: Record<string, any>,
): Configuration | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newConfiguration(value, cache);
  }
}
export interface SaveConfigurationResultOptions {
  __typename?: "SaveConfigurationResult";
  configuration?: ConfigurationOptions;
}

export function newSaveConfigurationResult(
  options: SaveConfigurationResultOptions = {},
  cache: Record<string, any> = {},
): SaveConfigurationResult {
  const o = (options.__typename ? options : cache["SaveConfigurationResult"] = {}) as SaveConfigurationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveConfigurationResult";
  o.configuration = maybeNewConfiguration(options.configuration, cache, options.hasOwnProperty("configuration"));
  return o;
}

factories["SaveConfigurationResult"] = newSaveConfigurationResult;

function maybeNewSaveConfigurationResult(
  value: SaveConfigurationResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveConfigurationResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveConfigurationResult"] || newSaveConfigurationResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveConfigurationResult(value, cache);
  }
}

function maybeNewOrNullSaveConfigurationResult(
  value: SaveConfigurationResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveConfigurationResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveConfigurationResult(value, cache);
  }
}
export interface ConfigurationToOptionOptions {
  __typename?: "ConfigurationToOption";
  id?: ConfigurationToOption["id"];
  createdAt?: ConfigurationToOption["createdAt"];
  airtableId?: ConfigurationToOption["airtableId"];
  updatedAt?: ConfigurationToOption["updatedAt"];
  configuration?: ConfigurationOptions;
  option?: OptionOptions;
}

export function newConfigurationToOption(
  options: ConfigurationToOptionOptions = {},
  cache: Record<string, any> = {},
): ConfigurationToOption {
  const o = (options.__typename ? options : cache["ConfigurationToOption"] = {}) as ConfigurationToOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ConfigurationToOption";
  o.id = options.id ?? nextFactoryId("ConfigurationToOption");
  o.createdAt = options.createdAt ?? newDateTime();
  o.airtableId = options.airtableId ?? "airtableId";
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.configuration = maybeNewConfiguration(options.configuration, cache, options.hasOwnProperty("configuration"));
  o.option = maybeNewOption(options.option, cache, options.hasOwnProperty("option"));
  return o;
}

factories["ConfigurationToOption"] = newConfigurationToOption;

function maybeNewConfigurationToOption(
  value: ConfigurationToOptionOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ConfigurationToOption {
  if (value === undefined) {
    return isSet ? undefined : cache["ConfigurationToOption"] || newConfigurationToOption({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newConfigurationToOption(value, cache);
  }
}

function maybeNewOrNullConfigurationToOption(
  value: ConfigurationToOptionOptions | undefined | null,
  cache: Record<string, any>,
): ConfigurationToOption | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newConfigurationToOption(value, cache);
  }
}
export interface SaveConfigurationToOptionResultOptions {
  __typename?: "SaveConfigurationToOptionResult";
  configurationToOption?: ConfigurationToOptionOptions;
}

export function newSaveConfigurationToOptionResult(
  options: SaveConfigurationToOptionResultOptions = {},
  cache: Record<string, any> = {},
): SaveConfigurationToOptionResult {
  const o =
    (options.__typename ? options : cache["SaveConfigurationToOptionResult"] = {}) as SaveConfigurationToOptionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveConfigurationToOptionResult";
  o.configurationToOption = maybeNewConfigurationToOption(
    options.configurationToOption,
    cache,
    options.hasOwnProperty("configurationToOption"),
  );
  return o;
}

factories["SaveConfigurationToOptionResult"] = newSaveConfigurationToOptionResult;

function maybeNewSaveConfigurationToOptionResult(
  value: SaveConfigurationToOptionResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveConfigurationToOptionResult {
  if (value === undefined) {
    return isSet
      ? undefined
      : cache["SaveConfigurationToOptionResult"] || newSaveConfigurationToOptionResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveConfigurationToOptionResult(value, cache);
  }
}

function maybeNewOrNullSaveConfigurationToOptionResult(
  value: SaveConfigurationToOptionResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveConfigurationToOptionResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveConfigurationToOptionResult(value, cache);
  }
}
export interface SaveConfigurationToOptionsResultOptions {
  __typename?: "SaveConfigurationToOptionsResult";
  configurationToOptions?: Array<ConfigurationToOptionOptions>;
}

export function newSaveConfigurationToOptionsResult(
  options: SaveConfigurationToOptionsResultOptions = {},
  cache: Record<string, any> = {},
): SaveConfigurationToOptionsResult {
  const o =
    (options.__typename ? options : cache["SaveConfigurationToOptionsResult"] = {}) as SaveConfigurationToOptionsResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveConfigurationToOptionsResult";
  o.configurationToOptions = (options.configurationToOptions ?? []).map((i) =>
    maybeNewConfigurationToOption(i, cache, options.hasOwnProperty("configurationToOptions"))
  );
  return o;
}

factories["SaveConfigurationToOptionsResult"] = newSaveConfigurationToOptionsResult;

function maybeNewSaveConfigurationToOptionsResult(
  value: SaveConfigurationToOptionsResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveConfigurationToOptionsResult {
  if (value === undefined) {
    return isSet
      ? undefined
      : cache["SaveConfigurationToOptionsResult"] || newSaveConfigurationToOptionsResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveConfigurationToOptionsResult(value, cache);
  }
}

function maybeNewOrNullSaveConfigurationToOptionsResult(
  value: SaveConfigurationToOptionsResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveConfigurationToOptionsResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveConfigurationToOptionsResult(value, cache);
  }
}
export interface ElevationOptions {
  __typename?: "Elevation";
  id?: Elevation["id"];
  airtableId?: Elevation["airtableId"];
  name?: Elevation["name"];
  priceInCents?: Elevation["priceInCents"];
  createdAt?: Elevation["createdAt"];
  updatedAt?: Elevation["updatedAt"];
  plan?: PlanOptions;
  configurations?: Array<ConfigurationOptions>;
  styles?: Array<ElevationStyleOptions>;
  specLevels?: Array<SpecLevelOptions>;
}

export function newElevation(options: ElevationOptions = {}, cache: Record<string, any> = {}): Elevation {
  const o = (options.__typename ? options : cache["Elevation"] = {}) as Elevation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Elevation";
  o.id = options.id ?? nextFactoryId("Elevation");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  o.styles = (options.styles ?? []).map((i) => maybeNewElevationStyle(i, cache, options.hasOwnProperty("styles")));
  o.specLevels = (options.specLevels ?? []).map((i) =>
    maybeNewSpecLevel(i, cache, options.hasOwnProperty("specLevels"))
  );
  return o;
}

factories["Elevation"] = newElevation;

function maybeNewElevation(
  value: ElevationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Elevation {
  if (value === undefined) {
    return isSet ? undefined : cache["Elevation"] || newElevation({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newElevation(value, cache);
  }
}

function maybeNewOrNullElevation(
  value: ElevationOptions | undefined | null,
  cache: Record<string, any>,
): Elevation | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newElevation(value, cache);
  }
}
export interface SaveElevationResultOptions {
  __typename?: "SaveElevationResult";
  elevation?: ElevationOptions;
}

export function newSaveElevationResult(
  options: SaveElevationResultOptions = {},
  cache: Record<string, any> = {},
): SaveElevationResult {
  const o = (options.__typename ? options : cache["SaveElevationResult"] = {}) as SaveElevationResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveElevationResult";
  o.elevation = maybeNewElevation(options.elevation, cache, options.hasOwnProperty("elevation"));
  return o;
}

factories["SaveElevationResult"] = newSaveElevationResult;

function maybeNewSaveElevationResult(
  value: SaveElevationResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveElevationResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveElevationResult"] || newSaveElevationResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveElevationResult(value, cache);
  }
}

function maybeNewOrNullSaveElevationResult(
  value: SaveElevationResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveElevationResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveElevationResult(value, cache);
  }
}
export interface ElevationStyleOptions {
  __typename?: "ElevationStyle";
  id?: ElevationStyle["id"];
  airtableId?: ElevationStyle["airtableId"];
  name?: ElevationStyle["name"];
  priceInCents?: ElevationStyle["priceInCents"];
  image?: ElevationStyle["image"];
  createdAt?: ElevationStyle["createdAt"];
  updatedAt?: ElevationStyle["updatedAt"];
  elevation?: ElevationOptions;
  configurations?: Array<ConfigurationOptions>;
  exteriorImages?: Array<ExteriorImageOptions>;
  sortOrder?: ElevationStyle["sortOrder"];
}

export function newElevationStyle(
  options: ElevationStyleOptions = {},
  cache: Record<string, any> = {},
): ElevationStyle {
  const o = (options.__typename ? options : cache["ElevationStyle"] = {}) as ElevationStyle;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ElevationStyle";
  o.id = options.id ?? nextFactoryId("ElevationStyle");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.priceInCents = options.priceInCents ?? 0;
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevation = maybeNewElevation(options.elevation, cache, options.hasOwnProperty("elevation"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  o.exteriorImages = (options.exteriorImages ?? []).map((i) =>
    maybeNewExteriorImage(i, cache, options.hasOwnProperty("exteriorImages"))
  );
  o.sortOrder = options.sortOrder ?? null;
  return o;
}

factories["ElevationStyle"] = newElevationStyle;

function maybeNewElevationStyle(
  value: ElevationStyleOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ElevationStyle {
  if (value === undefined) {
    return isSet ? undefined : cache["ElevationStyle"] || newElevationStyle({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newElevationStyle(value, cache);
  }
}

function maybeNewOrNullElevationStyle(
  value: ElevationStyleOptions | undefined | null,
  cache: Record<string, any>,
): ElevationStyle | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newElevationStyle(value, cache);
  }
}
export interface SaveElevationStyleResultOptions {
  __typename?: "SaveElevationStyleResult";
  elevationStyle?: ElevationStyleOptions;
}

export function newSaveElevationStyleResult(
  options: SaveElevationStyleResultOptions = {},
  cache: Record<string, any> = {},
): SaveElevationStyleResult {
  const o = (options.__typename ? options : cache["SaveElevationStyleResult"] = {}) as SaveElevationStyleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveElevationStyleResult";
  o.elevationStyle = maybeNewElevationStyle(options.elevationStyle, cache, options.hasOwnProperty("elevationStyle"));
  return o;
}

factories["SaveElevationStyleResult"] = newSaveElevationStyleResult;

function maybeNewSaveElevationStyleResult(
  value: SaveElevationStyleResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveElevationStyleResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveElevationStyleResult"] || newSaveElevationStyleResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveElevationStyleResult(value, cache);
  }
}

function maybeNewOrNullSaveElevationStyleResult(
  value: SaveElevationStyleResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveElevationStyleResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveElevationStyleResult(value, cache);
  }
}
export interface LotTypeDetailOptions {
  __typename?: "LotTypeDetail";
  code?: LotTypeDetail["code"];
  name?: LotTypeDetail["name"];
}

export function newLotTypeDetail(options: LotTypeDetailOptions = {}, cache: Record<string, any> = {}): LotTypeDetail {
  const o = (options.__typename ? options : cache["LotTypeDetail"] = {}) as LotTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "LotTypeDetail";
  o.code = options.code ?? LotType.Boyl;
  o.name = options.name ?? "Boyl";
  return o;
}

factories["LotTypeDetail"] = newLotTypeDetail;

export interface UserTypeDetailOptions {
  __typename?: "UserTypeDetail";
  code?: UserTypeDetail["code"];
  name?: UserTypeDetail["name"];
}

export function newUserTypeDetail(
  options: UserTypeDetailOptions = {},
  cache: Record<string, any> = {},
): UserTypeDetail {
  const o = (options.__typename ? options : cache["UserTypeDetail"] = {}) as UserTypeDetail;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserTypeDetail";
  o.code = options.code ?? UserType.Anonymous;
  o.name = options.name ?? "Anonymous";
  return o;
}

factories["UserTypeDetail"] = newUserTypeDetail;

export interface ExteriorImageOptions {
  __typename?: "ExteriorImage";
  id?: ExteriorImage["id"];
  airtableId?: ExteriorImage["airtableId"];
  image?: ExteriorImage["image"];
  createdAt?: ExteriorImage["createdAt"];
  updatedAt?: ExteriorImage["updatedAt"];
  elevationStyle?: ElevationStyleOptions;
  sortOrder?: ExteriorImage["sortOrder"];
}

export function newExteriorImage(options: ExteriorImageOptions = {}, cache: Record<string, any> = {}): ExteriorImage {
  const o = (options.__typename ? options : cache["ExteriorImage"] = {}) as ExteriorImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ExteriorImage";
  o.id = options.id ?? nextFactoryId("ExteriorImage");
  o.airtableId = options.airtableId ?? "airtableId";
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevationStyle = maybeNewElevationStyle(options.elevationStyle, cache, options.hasOwnProperty("elevationStyle"));
  o.sortOrder = options.sortOrder ?? null;
  return o;
}

factories["ExteriorImage"] = newExteriorImage;

function maybeNewExteriorImage(
  value: ExteriorImageOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ExteriorImage {
  if (value === undefined) {
    return isSet ? undefined : cache["ExteriorImage"] || newExteriorImage({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newExteriorImage(value, cache);
  }
}

function maybeNewOrNullExteriorImage(
  value: ExteriorImageOptions | undefined | null,
  cache: Record<string, any>,
): ExteriorImage | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newExteriorImage(value, cache);
  }
}
export interface SaveExteriorImageResultOptions {
  __typename?: "SaveExteriorImageResult";
  exteriorImage?: ExteriorImageOptions;
}

export function newSaveExteriorImageResult(
  options: SaveExteriorImageResultOptions = {},
  cache: Record<string, any> = {},
): SaveExteriorImageResult {
  const o = (options.__typename ? options : cache["SaveExteriorImageResult"] = {}) as SaveExteriorImageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveExteriorImageResult";
  o.exteriorImage = maybeNewExteriorImage(options.exteriorImage, cache, options.hasOwnProperty("exteriorImage"));
  return o;
}

factories["SaveExteriorImageResult"] = newSaveExteriorImageResult;

function maybeNewSaveExteriorImageResult(
  value: SaveExteriorImageResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveExteriorImageResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveExteriorImageResult"] || newSaveExteriorImageResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveExteriorImageResult(value, cache);
  }
}

function maybeNewOrNullSaveExteriorImageResult(
  value: SaveExteriorImageResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveExteriorImageResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveExteriorImageResult(value, cache);
  }
}
export interface FloorOptions {
  __typename?: "Floor";
  id?: Floor["id"];
  airtableId?: Floor["airtableId"];
  name?: Floor["name"];
  image?: Floor["image"];
  createdAt?: Floor["createdAt"];
  updatedAt?: Floor["updatedAt"];
  plan?: PlanOptions;
  options?: Array<OptionOptions>;
}

export function newFloor(options: FloorOptions = {}, cache: Record<string, any> = {}): Floor {
  const o = (options.__typename ? options : cache["Floor"] = {}) as Floor;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Floor";
  o.id = options.id ?? nextFactoryId("Floor");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  o.options = (options.options ?? []).map((i) => maybeNewOption(i, cache, options.hasOwnProperty("options")));
  return o;
}

factories["Floor"] = newFloor;

function maybeNewFloor(value: FloorOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Floor {
  if (value === undefined) {
    return isSet ? undefined : cache["Floor"] || newFloor({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newFloor(value, cache);
  }
}

function maybeNewOrNullFloor(value: FloorOptions | undefined | null, cache: Record<string, any>): Floor | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newFloor(value, cache);
  }
}
export interface SaveFloorResultOptions {
  __typename?: "SaveFloorResult";
  floor?: FloorOptions;
}

export function newSaveFloorResult(
  options: SaveFloorResultOptions = {},
  cache: Record<string, any> = {},
): SaveFloorResult {
  const o = (options.__typename ? options : cache["SaveFloorResult"] = {}) as SaveFloorResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveFloorResult";
  o.floor = maybeNewFloor(options.floor, cache, options.hasOwnProperty("floor"));
  return o;
}

factories["SaveFloorResult"] = newSaveFloorResult;

function maybeNewSaveFloorResult(
  value: SaveFloorResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveFloorResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveFloorResult"] || newSaveFloorResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveFloorResult(value, cache);
  }
}

function maybeNewOrNullSaveFloorResult(
  value: SaveFloorResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveFloorResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveFloorResult(value, cache);
  }
}
export interface GSheetOptionPricingOptions {
  __typename?: "GSheetOptionPricing";
  id?: GSheetOptionPricing["id"];
  price?: GSheetOptionPricing["price"];
}

export function newGSheetOptionPricing(
  options: GSheetOptionPricingOptions = {},
  cache: Record<string, any> = {},
): GSheetOptionPricing {
  const o = (options.__typename ? options : cache["GSheetOptionPricing"] = {}) as GSheetOptionPricing;
  (cache.all ??= new Set()).add(o);
  o.__typename = "GSheetOptionPricing";
  o.id = options.id ?? nextFactoryId("GSheetOptionPricing");
  o.price = options.price ?? 0;
  return o;
}

factories["GSheetOptionPricing"] = newGSheetOptionPricing;

function maybeNewGSheetOptionPricing(
  value: GSheetOptionPricingOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): GSheetOptionPricing {
  if (value === undefined) {
    return isSet ? undefined : cache["GSheetOptionPricing"] || newGSheetOptionPricing({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newGSheetOptionPricing(value, cache);
  }
}

function maybeNewOrNullGSheetOptionPricing(
  value: GSheetOptionPricingOptions | undefined | null,
  cache: Record<string, any>,
): GSheetOptionPricing | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newGSheetOptionPricing(value, cache);
  }
}
export interface HelloWorldOptions {
  __typename?: "HelloWorld";
  id?: HelloWorld["id"];
  name?: HelloWorld["name"];
  description?: HelloWorld["description"];
  priceInCents?: HelloWorld["priceInCents"];
  createdAt?: HelloWorld["createdAt"];
  updatedAt?: HelloWorld["updatedAt"];
  isActive?: HelloWorld["isActive"];
}

export function newHelloWorld(options: HelloWorldOptions = {}, cache: Record<string, any> = {}): HelloWorld {
  const o = (options.__typename ? options : cache["HelloWorld"] = {}) as HelloWorld;
  (cache.all ??= new Set()).add(o);
  o.__typename = "HelloWorld";
  o.id = options.id ?? nextFactoryId("HelloWorld");
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.isActive = options.isActive ?? null;
  return o;
}

factories["HelloWorld"] = newHelloWorld;

function maybeNewHelloWorld(
  value: HelloWorldOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): HelloWorld {
  if (value === undefined) {
    return isSet ? undefined : cache["HelloWorld"] || newHelloWorld({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHelloWorld(value, cache);
  }
}

function maybeNewOrNullHelloWorld(
  value: HelloWorldOptions | undefined | null,
  cache: Record<string, any>,
): HelloWorld | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHelloWorld(value, cache);
  }
}
export interface SaveHelloWorldResultOptions {
  __typename?: "SaveHelloWorldResult";
  helloWorld?: HelloWorldOptions;
}

export function newSaveHelloWorldResult(
  options: SaveHelloWorldResultOptions = {},
  cache: Record<string, any> = {},
): SaveHelloWorldResult {
  const o = (options.__typename ? options : cache["SaveHelloWorldResult"] = {}) as SaveHelloWorldResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHelloWorldResult";
  o.helloWorld = maybeNewHelloWorld(options.helloWorld, cache, options.hasOwnProperty("helloWorld"));
  return o;
}

factories["SaveHelloWorldResult"] = newSaveHelloWorldResult;

function maybeNewSaveHelloWorldResult(
  value: SaveHelloWorldResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveHelloWorldResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveHelloWorldResult"] || newSaveHelloWorldResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveHelloWorldResult(value, cache);
  }
}

function maybeNewOrNullSaveHelloWorldResult(
  value: SaveHelloWorldResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveHelloWorldResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveHelloWorldResult(value, cache);
  }
}
export interface HomeownerOptions {
  __typename?: "Homeowner";
  id?: Homeowner["id"];
  firstName?: Homeowner["firstName"];
  lastName?: Homeowner["lastName"];
  createdAt?: Homeowner["createdAt"];
  updatedAt?: Homeowner["updatedAt"];
  user?: UserOptions;
  lastActive?: Homeowner["lastActive"];
}

export function newHomeowner(options: HomeownerOptions = {}, cache: Record<string, any> = {}): Homeowner {
  const o = (options.__typename ? options : cache["Homeowner"] = {}) as Homeowner;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Homeowner";
  o.id = options.id ?? nextFactoryId("Homeowner");
  o.firstName = options.firstName ?? "firstName";
  o.lastName = options.lastName ?? "lastName";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.user = maybeNewUser(options.user, cache, options.hasOwnProperty("user"));
  o.lastActive = options.lastActive ?? null;
  return o;
}

factories["Homeowner"] = newHomeowner;

function maybeNewHomeowner(
  value: HomeownerOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Homeowner {
  if (value === undefined) {
    return isSet ? undefined : cache["Homeowner"] || newHomeowner({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHomeowner(value, cache);
  }
}

function maybeNewOrNullHomeowner(
  value: HomeownerOptions | undefined | null,
  cache: Record<string, any>,
): Homeowner | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHomeowner(value, cache);
  }
}
export interface SaveHomeownerResultOptions {
  __typename?: "SaveHomeownerResult";
  homeowner?: HomeownerOptions;
}

export function newSaveHomeownerResult(
  options: SaveHomeownerResultOptions = {},
  cache: Record<string, any> = {},
): SaveHomeownerResult {
  const o = (options.__typename ? options : cache["SaveHomeownerResult"] = {}) as SaveHomeownerResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveHomeownerResult";
  o.homeowner = maybeNewHomeowner(options.homeowner, cache, options.hasOwnProperty("homeowner"));
  return o;
}

factories["SaveHomeownerResult"] = newSaveHomeownerResult;

function maybeNewSaveHomeownerResult(
  value: SaveHomeownerResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveHomeownerResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveHomeownerResult"] || newSaveHomeownerResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveHomeownerResult(value, cache);
  }
}

function maybeNewOrNullSaveHomeownerResult(
  value: SaveHomeownerResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveHomeownerResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveHomeownerResult(value, cache);
  }
}
export interface InteriorImageOptions {
  __typename?: "InteriorImage";
  id?: InteriorImage["id"];
  airtableId?: InteriorImage["airtableId"];
  name?: InteriorImage["name"];
  image?: InteriorImage["image"];
  createdAt?: InteriorImage["createdAt"];
  updatedAt?: InteriorImage["updatedAt"];
  specLevelStyle?: SpecLevelStyleOptions;
  sortOrder?: InteriorImage["sortOrder"];
}

export function newInteriorImage(options: InteriorImageOptions = {}, cache: Record<string, any> = {}): InteriorImage {
  const o = (options.__typename ? options : cache["InteriorImage"] = {}) as InteriorImage;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InteriorImage";
  o.id = options.id ?? nextFactoryId("InteriorImage");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.specLevelStyle = maybeNewSpecLevelStyle(options.specLevelStyle, cache, options.hasOwnProperty("specLevelStyle"));
  o.sortOrder = options.sortOrder ?? null;
  return o;
}

factories["InteriorImage"] = newInteriorImage;

function maybeNewInteriorImage(
  value: InteriorImageOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): InteriorImage {
  if (value === undefined) {
    return isSet ? undefined : cache["InteriorImage"] || newInteriorImage({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newInteriorImage(value, cache);
  }
}

function maybeNewOrNullInteriorImage(
  value: InteriorImageOptions | undefined | null,
  cache: Record<string, any>,
): InteriorImage | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newInteriorImage(value, cache);
  }
}
export interface SaveInteriorImageResultOptions {
  __typename?: "SaveInteriorImageResult";
  interiorImage?: InteriorImageOptions;
}

export function newSaveInteriorImageResult(
  options: SaveInteriorImageResultOptions = {},
  cache: Record<string, any> = {},
): SaveInteriorImageResult {
  const o = (options.__typename ? options : cache["SaveInteriorImageResult"] = {}) as SaveInteriorImageResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInteriorImageResult";
  o.interiorImage = maybeNewInteriorImage(options.interiorImage, cache, options.hasOwnProperty("interiorImage"));
  return o;
}

factories["SaveInteriorImageResult"] = newSaveInteriorImageResult;

function maybeNewSaveInteriorImageResult(
  value: SaveInteriorImageResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveInteriorImageResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveInteriorImageResult"] || newSaveInteriorImageResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveInteriorImageResult(value, cache);
  }
}

function maybeNewOrNullSaveInteriorImageResult(
  value: SaveInteriorImageResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveInteriorImageResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveInteriorImageResult(value, cache);
  }
}
export interface InternalUserOptions {
  __typename?: "InternalUser";
  id?: InternalUser["id"];
  name?: InternalUser["name"];
  avatarUrl?: InternalUser["avatarUrl"];
  createdAt?: InternalUser["createdAt"];
  updatedAt?: InternalUser["updatedAt"];
  user?: UserOptions;
}

export function newInternalUser(options: InternalUserOptions = {}, cache: Record<string, any> = {}): InternalUser {
  const o = (options.__typename ? options : cache["InternalUser"] = {}) as InternalUser;
  (cache.all ??= new Set()).add(o);
  o.__typename = "InternalUser";
  o.id = options.id ?? nextFactoryId("InternalUser");
  o.name = options.name ?? "name";
  o.avatarUrl = options.avatarUrl ?? "avatarUrl";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.user = maybeNewUser(options.user, cache, options.hasOwnProperty("user"));
  return o;
}

factories["InternalUser"] = newInternalUser;

function maybeNewInternalUser(
  value: InternalUserOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): InternalUser {
  if (value === undefined) {
    return isSet ? undefined : cache["InternalUser"] || newInternalUser({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newInternalUser(value, cache);
  }
}

function maybeNewOrNullInternalUser(
  value: InternalUserOptions | undefined | null,
  cache: Record<string, any>,
): InternalUser | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newInternalUser(value, cache);
  }
}
export interface SaveInternalUserResultOptions {
  __typename?: "SaveInternalUserResult";
  internalUser?: InternalUserOptions;
}

export function newSaveInternalUserResult(
  options: SaveInternalUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveInternalUserResult {
  const o = (options.__typename ? options : cache["SaveInternalUserResult"] = {}) as SaveInternalUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveInternalUserResult";
  o.internalUser = maybeNewInternalUser(options.internalUser, cache, options.hasOwnProperty("internalUser"));
  return o;
}

factories["SaveInternalUserResult"] = newSaveInternalUserResult;

function maybeNewSaveInternalUserResult(
  value: SaveInternalUserResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveInternalUserResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveInternalUserResult"] || newSaveInternalUserResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveInternalUserResult(value, cache);
  }
}

function maybeNewOrNullSaveInternalUserResult(
  value: SaveInternalUserResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveInternalUserResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveInternalUserResult(value, cache);
  }
}
export interface OptionOptions {
  __typename?: "Option";
  id?: Option["id"];
  airtableId?: Option["airtableId"];
  name?: Option["name"];
  description?: Option["description"];
  optionCode?: Option["optionCode"];
  bedrooms?: Option["bedrooms"];
  bathrooms?: Option["bathrooms"];
  garageParking?: Option["garageParking"];
  sqft?: Option["sqft"];
  image?: Option["image"];
  location?: Option["location"];
  createdAt?: Option["createdAt"];
  updatedAt?: Option["updatedAt"];
  floor?: FloorOptions | null;
  priceInCents?: Option["priceInCents"];
  group?: Option["group"];
  configurationTos?: Array<ConfigurationToOptionOptions>;
  conflictOptionToOptions?: Array<OptionToOptionOptions>;
  optionToOptions?: Array<OptionToOptionOptions>;
  toSpecLevels?: Array<OptionToSpecLevelOptions>;
  baseSqft?: Option["baseSqft"];
  floorPlanImage?: Option["floorPlanImage"];
}

export function newOption(options: OptionOptions = {}, cache: Record<string, any> = {}): Option {
  const o = (options.__typename ? options : cache["Option"] = {}) as Option;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Option";
  o.id = options.id ?? nextFactoryId("Option");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.optionCode = options.optionCode ?? "optionCode";
  o.bedrooms = options.bedrooms ?? "bedrooms";
  o.bathrooms = options.bathrooms ?? "bathrooms";
  o.garageParking = options.garageParking ?? "garageParking";
  o.sqft = options.sqft ?? "sqft";
  o.image = options.image ?? null;
  o.location = options.location ?? "location";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.floor = maybeNewOrNullFloor(options.floor, cache);
  o.priceInCents = options.priceInCents ?? 0;
  o.group = options.group ?? "group";
  o.configurationTos = (options.configurationTos ?? []).map((i) =>
    maybeNewConfigurationToOption(i, cache, options.hasOwnProperty("configurationTos"))
  );
  o.conflictOptionToOptions = (options.conflictOptionToOptions ?? []).map((i) =>
    maybeNewOptionToOption(i, cache, options.hasOwnProperty("conflictOptionToOptions"))
  );
  o.optionToOptions = (options.optionToOptions ?? []).map((i) =>
    maybeNewOptionToOption(i, cache, options.hasOwnProperty("optionToOptions"))
  );
  o.toSpecLevels = (options.toSpecLevels ?? []).map((i) =>
    maybeNewOptionToSpecLevel(i, cache, options.hasOwnProperty("toSpecLevels"))
  );
  o.baseSqft = options.baseSqft ?? 0;
  o.floorPlanImage = options.floorPlanImage ?? null;
  return o;
}

factories["Option"] = newOption;

function maybeNewOption(value: OptionOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Option {
  if (value === undefined) {
    return isSet ? undefined : cache["Option"] || newOption({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOption(value, cache);
  }
}

function maybeNewOrNullOption(value: OptionOptions | undefined | null, cache: Record<string, any>): Option | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOption(value, cache);
  }
}
export interface SaveOptionResultOptions {
  __typename?: "SaveOptionResult";
  option?: OptionOptions;
}

export function newSaveOptionResult(
  options: SaveOptionResultOptions = {},
  cache: Record<string, any> = {},
): SaveOptionResult {
  const o = (options.__typename ? options : cache["SaveOptionResult"] = {}) as SaveOptionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveOptionResult";
  o.option = maybeNewOption(options.option, cache, options.hasOwnProperty("option"));
  return o;
}

factories["SaveOptionResult"] = newSaveOptionResult;

function maybeNewSaveOptionResult(
  value: SaveOptionResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveOptionResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveOptionResult"] || newSaveOptionResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveOptionResult(value, cache);
  }
}

function maybeNewOrNullSaveOptionResult(
  value: SaveOptionResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveOptionResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveOptionResult(value, cache);
  }
}
export interface OptionToOptionOptions {
  __typename?: "OptionToOption";
  id?: OptionToOption["id"];
  airtableId?: OptionToOption["airtableId"];
  createdAt?: OptionToOption["createdAt"];
  updatedAt?: OptionToOption["updatedAt"];
  conflictOption?: OptionOptions;
  option?: OptionOptions;
}

export function newOptionToOption(
  options: OptionToOptionOptions = {},
  cache: Record<string, any> = {},
): OptionToOption {
  const o = (options.__typename ? options : cache["OptionToOption"] = {}) as OptionToOption;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionToOption";
  o.id = options.id ?? nextFactoryId("OptionToOption");
  o.airtableId = options.airtableId ?? "airtableId";
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.conflictOption = maybeNewOption(options.conflictOption, cache, options.hasOwnProperty("conflictOption"));
  o.option = maybeNewOption(options.option, cache, options.hasOwnProperty("option"));
  return o;
}

factories["OptionToOption"] = newOptionToOption;

function maybeNewOptionToOption(
  value: OptionToOptionOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): OptionToOption {
  if (value === undefined) {
    return isSet ? undefined : cache["OptionToOption"] || newOptionToOption({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOptionToOption(value, cache);
  }
}

function maybeNewOrNullOptionToOption(
  value: OptionToOptionOptions | undefined | null,
  cache: Record<string, any>,
): OptionToOption | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOptionToOption(value, cache);
  }
}
export interface SaveOptionToOptionResultOptions {
  __typename?: "SaveOptionToOptionResult";
  optionToOption?: OptionToOptionOptions;
}

export function newSaveOptionToOptionResult(
  options: SaveOptionToOptionResultOptions = {},
  cache: Record<string, any> = {},
): SaveOptionToOptionResult {
  const o = (options.__typename ? options : cache["SaveOptionToOptionResult"] = {}) as SaveOptionToOptionResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveOptionToOptionResult";
  o.optionToOption = maybeNewOptionToOption(options.optionToOption, cache, options.hasOwnProperty("optionToOption"));
  return o;
}

factories["SaveOptionToOptionResult"] = newSaveOptionToOptionResult;

function maybeNewSaveOptionToOptionResult(
  value: SaveOptionToOptionResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveOptionToOptionResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveOptionToOptionResult"] || newSaveOptionToOptionResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveOptionToOptionResult(value, cache);
  }
}

function maybeNewOrNullSaveOptionToOptionResult(
  value: SaveOptionToOptionResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveOptionToOptionResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveOptionToOptionResult(value, cache);
  }
}
export interface OptionToSpecLevelOptions {
  __typename?: "OptionToSpecLevel";
  id?: OptionToSpecLevel["id"];
  createdAt?: OptionToSpecLevel["createdAt"];
  airtableId?: OptionToSpecLevel["airtableId"];
  priceInCents?: OptionToSpecLevel["priceInCents"];
  updatedAt?: OptionToSpecLevel["updatedAt"];
  option?: OptionOptions;
  specLevel?: SpecLevelOptions;
}

export function newOptionToSpecLevel(
  options: OptionToSpecLevelOptions = {},
  cache: Record<string, any> = {},
): OptionToSpecLevel {
  const o = (options.__typename ? options : cache["OptionToSpecLevel"] = {}) as OptionToSpecLevel;
  (cache.all ??= new Set()).add(o);
  o.__typename = "OptionToSpecLevel";
  o.id = options.id ?? nextFactoryId("OptionToSpecLevel");
  o.createdAt = options.createdAt ?? newDateTime();
  o.airtableId = options.airtableId ?? "airtableId";
  o.priceInCents = options.priceInCents ?? 0;
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.option = maybeNewOption(options.option, cache, options.hasOwnProperty("option"));
  o.specLevel = maybeNewSpecLevel(options.specLevel, cache, options.hasOwnProperty("specLevel"));
  return o;
}

factories["OptionToSpecLevel"] = newOptionToSpecLevel;

function maybeNewOptionToSpecLevel(
  value: OptionToSpecLevelOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): OptionToSpecLevel {
  if (value === undefined) {
    return isSet ? undefined : cache["OptionToSpecLevel"] || newOptionToSpecLevel({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOptionToSpecLevel(value, cache);
  }
}

function maybeNewOrNullOptionToSpecLevel(
  value: OptionToSpecLevelOptions | undefined | null,
  cache: Record<string, any>,
): OptionToSpecLevel | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newOptionToSpecLevel(value, cache);
  }
}
export interface SaveOptionToSpecLevelResultOptions {
  __typename?: "SaveOptionToSpecLevelResult";
  optionToSpecLevel?: OptionToSpecLevelOptions;
}

export function newSaveOptionToSpecLevelResult(
  options: SaveOptionToSpecLevelResultOptions = {},
  cache: Record<string, any> = {},
): SaveOptionToSpecLevelResult {
  const o = (options.__typename ? options : cache["SaveOptionToSpecLevelResult"] = {}) as SaveOptionToSpecLevelResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveOptionToSpecLevelResult";
  o.optionToSpecLevel = maybeNewOptionToSpecLevel(
    options.optionToSpecLevel,
    cache,
    options.hasOwnProperty("optionToSpecLevel"),
  );
  return o;
}

factories["SaveOptionToSpecLevelResult"] = newSaveOptionToSpecLevelResult;

function maybeNewSaveOptionToSpecLevelResult(
  value: SaveOptionToSpecLevelResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveOptionToSpecLevelResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveOptionToSpecLevelResult"] || newSaveOptionToSpecLevelResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveOptionToSpecLevelResult(value, cache);
  }
}

function maybeNewOrNullSaveOptionToSpecLevelResult(
  value: SaveOptionToSpecLevelResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveOptionToSpecLevelResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveOptionToSpecLevelResult(value, cache);
  }
}
export interface PlanOptions {
  __typename?: "Plan";
  id?: Plan["id"];
  airtableId?: Plan["airtableId"];
  name?: Plan["name"];
  description?: Plan["description"];
  priceInCents?: Plan["priceInCents"];
  bedrooms?: Plan["bedrooms"];
  bathrooms?: Plan["bathrooms"];
  garageParking?: Plan["garageParking"];
  sqft?: Plan["sqft"];
  createdAt?: Plan["createdAt"];
  updatedAt?: Plan["updatedAt"];
  configurations?: Array<ConfigurationOptions>;
  elevations?: Array<ElevationOptions>;
  floors?: Array<FloorOptions>;
  baseSqft?: Plan["baseSqft"];
}

export function newPlan(options: PlanOptions = {}, cache: Record<string, any> = {}): Plan {
  const o = (options.__typename ? options : cache["Plan"] = {}) as Plan;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Plan";
  o.id = options.id ?? nextFactoryId("Plan");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.description = options.description ?? null;
  o.priceInCents = options.priceInCents ?? 0;
  o.bedrooms = options.bedrooms ?? null;
  o.bathrooms = options.bathrooms ?? null;
  o.garageParking = options.garageParking ?? null;
  o.sqft = options.sqft ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  o.elevations = (options.elevations ?? []).map((i) =>
    maybeNewElevation(i, cache, options.hasOwnProperty("elevations"))
  );
  o.floors = (options.floors ?? []).map((i) => maybeNewFloor(i, cache, options.hasOwnProperty("floors")));
  o.baseSqft = options.baseSqft ?? 0;
  return o;
}

factories["Plan"] = newPlan;

function maybeNewPlan(value: PlanOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Plan {
  if (value === undefined) {
    return isSet ? undefined : cache["Plan"] || newPlan({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlan(value, cache);
  }
}

function maybeNewOrNullPlan(value: PlanOptions | undefined | null, cache: Record<string, any>): Plan | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPlan(value, cache);
  }
}
export interface SavePlanResultOptions {
  __typename?: "SavePlanResult";
  plan?: PlanOptions;
}

export function newSavePlanResult(
  options: SavePlanResultOptions = {},
  cache: Record<string, any> = {},
): SavePlanResult {
  const o = (options.__typename ? options : cache["SavePlanResult"] = {}) as SavePlanResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SavePlanResult";
  o.plan = maybeNewPlan(options.plan, cache, options.hasOwnProperty("plan"));
  return o;
}

factories["SavePlanResult"] = newSavePlanResult;

function maybeNewSavePlanResult(
  value: SavePlanResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SavePlanResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SavePlanResult"] || newSavePlanResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSavePlanResult(value, cache);
  }
}

function maybeNewOrNullSavePlanResult(
  value: SavePlanResultOptions | undefined | null,
  cache: Record<string, any>,
): SavePlanResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSavePlanResult(value, cache);
  }
}
export interface PropertyOptions {
  __typename?: "Property";
  dpid?: Property["dpid"];
  fullStreetAddress?: Property["fullStreetAddress"];
  cityName?: Property["cityName"];
  state?: Property["state"];
  zipCode?: Property["zipCode"];
  latitude?: Property["latitude"];
  longitude?: Property["longitude"];
  unitNumber?: Property["unitNumber"];
  propertyTypeSimple?: Property["propertyTypeSimple"];
  lotSize?: Property["lotSize"];
  yearBuiltOrRenovated?: Property["yearBuiltOrRenovated"];
  finishedSqft?: Property["finishedSqft"];
  totalSqft?: Property["totalSqft"];
  numBedrooms?: Property["numBedrooms"];
  numBaths?: Property["numBaths"];
  numStories?: Property["numStories"];
  hasPool?: Property["hasPool"];
  garageNumCars?: Property["garageNumCars"];
  buildableSqft?: Property["buildableSqft"];
  lotFrontageFeet?: Property["lotFrontageFeet"];
  lotDepthFeet?: Property["lotDepthFeet"];
  zoning?: Property["zoning"];
}

export function newProperty(options: PropertyOptions = {}, cache: Record<string, any> = {}): Property {
  const o = (options.__typename ? options : cache["Property"] = {}) as Property;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Property";
  o.dpid = options.dpid ?? nextFactoryId("Property");
  o.fullStreetAddress = options.fullStreetAddress ?? "fullStreetAddress";
  o.cityName = options.cityName ?? "cityName";
  o.state = options.state ?? "state";
  o.zipCode = options.zipCode ?? "zipCode";
  o.latitude = options.latitude ?? "" as any;
  o.longitude = options.longitude ?? "" as any;
  o.unitNumber = options.unitNumber ?? null;
  o.propertyTypeSimple = options.propertyTypeSimple ?? null;
  o.lotSize = options.lotSize ?? null;
  o.yearBuiltOrRenovated = options.yearBuiltOrRenovated ?? null;
  o.finishedSqft = options.finishedSqft ?? null;
  o.totalSqft = options.totalSqft ?? null;
  o.numBedrooms = options.numBedrooms ?? null;
  o.numBaths = options.numBaths ?? null;
  o.numStories = options.numStories ?? null;
  o.hasPool = options.hasPool ?? null;
  o.garageNumCars = options.garageNumCars ?? null;
  o.buildableSqft = options.buildableSqft ?? null;
  o.lotFrontageFeet = options.lotFrontageFeet ?? null;
  o.lotDepthFeet = options.lotDepthFeet ?? null;
  o.zoning = options.zoning ?? null;
  return o;
}

factories["Property"] = newProperty;

function maybeNewProperty(
  value: PropertyOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): Property {
  if (value === undefined) {
    return isSet ? undefined : cache["Property"] || newProperty({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newProperty(value, cache);
  }
}

function maybeNewOrNullProperty(
  value: PropertyOptions | undefined | null,
  cache: Record<string, any>,
): Property | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newProperty(value, cache);
  }
}
export interface UrlOptions {
  __typename?: "Url";
  path?: Url["path"];
  url?: Url["url"];
}

export function newUrl(options: UrlOptions = {}, cache: Record<string, any> = {}): Url {
  const o = (options.__typename ? options : cache["Url"] = {}) as Url;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Url";
  o.path = options.path ?? "path";
  o.url = options.url ?? "url";
  return o;
}

factories["Url"] = newUrl;

function maybeNewUrl(value: UrlOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Url {
  if (value === undefined) {
    return isSet ? undefined : cache["Url"] || newUrl({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUrl(value, cache);
  }
}

function maybeNewOrNullUrl(value: UrlOptions | undefined | null, cache: Record<string, any>): Url | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUrl(value, cache);
  }
}
export interface PotentialOperationOptions {
  __typename?: "PotentialOperation";
  allowed?: PotentialOperation["allowed"];
  disabledReasons?: Array<ReasonOptions>;
}

export function newPotentialOperation(
  options: PotentialOperationOptions = {},
  cache: Record<string, any> = {},
): PotentialOperation {
  const o = (options.__typename ? options : cache["PotentialOperation"] = {}) as PotentialOperation;
  (cache.all ??= new Set()).add(o);
  o.__typename = "PotentialOperation";
  o.allowed = options.allowed ?? false;
  o.disabledReasons = (options.disabledReasons ?? []).map((i) =>
    maybeNewReason(i, cache, options.hasOwnProperty("disabledReasons"))
  );
  return o;
}

factories["PotentialOperation"] = newPotentialOperation;

function maybeNewPotentialOperation(
  value: PotentialOperationOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): PotentialOperation {
  if (value === undefined) {
    return isSet ? undefined : cache["PotentialOperation"] || newPotentialOperation({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPotentialOperation(value, cache);
  }
}

function maybeNewOrNullPotentialOperation(
  value: PotentialOperationOptions | undefined | null,
  cache: Record<string, any>,
): PotentialOperation | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newPotentialOperation(value, cache);
  }
}
export interface ReasonOptions {
  __typename?: "Reason";
  message?: Reason["message"];
}

export function newReason(options: ReasonOptions = {}, cache: Record<string, any> = {}): Reason {
  const o = (options.__typename ? options : cache["Reason"] = {}) as Reason;
  (cache.all ??= new Set()).add(o);
  o.__typename = "Reason";
  o.message = options.message ?? "message";
  return o;
}

factories["Reason"] = newReason;

function maybeNewReason(value: ReasonOptions | undefined, cache: Record<string, any>, isSet: boolean = false): Reason {
  if (value === undefined) {
    return isSet ? undefined : cache["Reason"] || newReason({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newReason(value, cache);
  }
}

function maybeNewOrNullReason(value: ReasonOptions | undefined | null, cache: Record<string, any>): Reason | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newReason(value, cache);
  }
}
export interface UserErrorOptions {
  __typename?: "UserError";
  message?: UserError["message"];
}

export function newUserError(options: UserErrorOptions = {}, cache: Record<string, any> = {}): UserError {
  const o = (options.__typename ? options : cache["UserError"] = {}) as UserError;
  (cache.all ??= new Set()).add(o);
  o.__typename = "UserError";
  o.message = options.message ?? "message";
  return o;
}

factories["UserError"] = newUserError;

function maybeNewUserError(
  value: UserErrorOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): UserError {
  if (value === undefined) {
    return isSet ? undefined : cache["UserError"] || newUserError({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUserError(value, cache);
  }
}

function maybeNewOrNullUserError(
  value: UserErrorOptions | undefined | null,
  cache: Record<string, any>,
): UserError | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUserError(value, cache);
  }
}
export interface EmptyResultOptions {
  __typename?: "EmptyResult";
  emptyResult?: EmptyResult["emptyResult"];
}

export function newEmptyResult(options: EmptyResultOptions = {}, cache: Record<string, any> = {}): EmptyResult {
  const o = (options.__typename ? options : cache["EmptyResult"] = {}) as EmptyResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "EmptyResult";
  o.emptyResult = options.emptyResult ?? null;
  return o;
}

factories["EmptyResult"] = newEmptyResult;

function maybeNewEmptyResult(
  value: EmptyResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): EmptyResult {
  if (value === undefined) {
    return isSet ? undefined : cache["EmptyResult"] || newEmptyResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newEmptyResult(value, cache);
  }
}

function maybeNewOrNullEmptyResult(
  value: EmptyResultOptions | undefined | null,
  cache: Record<string, any>,
): EmptyResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newEmptyResult(value, cache);
  }
}
export interface HistoryOptions {
  __typename?: "History";
  recordedAt?: History["recordedAt"];
  avatar?: History["avatar"];
  title?: History["title"];
  subtitle?: History["subtitle"];
}

export function newHistory(options: HistoryOptions = {}, cache: Record<string, any> = {}): History {
  const o = (options.__typename ? options : cache["History"] = {}) as History;
  (cache.all ??= new Set()).add(o);
  o.__typename = "History";
  o.recordedAt = options.recordedAt ?? newDateTime();
  o.avatar = options.avatar ?? "avatar";
  o.title = options.title ?? "title";
  o.subtitle = options.subtitle ?? null;
  return o;
}

factories["History"] = newHistory;

function maybeNewHistory(
  value: HistoryOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): History {
  if (value === undefined) {
    return isSet ? undefined : cache["History"] || newHistory({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHistory(value, cache);
  }
}

function maybeNewOrNullHistory(value: HistoryOptions | undefined | null, cache: Record<string, any>): History | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newHistory(value, cache);
  }
}
export interface SpecLevelOptions {
  __typename?: "SpecLevel";
  id?: SpecLevel["id"];
  airtableId?: SpecLevel["airtableId"];
  name?: SpecLevel["name"];
  priceInCents?: SpecLevel["priceInCents"];
  createdAt?: SpecLevel["createdAt"];
  updatedAt?: SpecLevel["updatedAt"];
  elevation?: ElevationOptions;
  configurations?: Array<ConfigurationOptions>;
  optionTos?: Array<OptionToSpecLevelOptions>;
  styles?: Array<SpecLevelStyleOptions>;
}

export function newSpecLevel(options: SpecLevelOptions = {}, cache: Record<string, any> = {}): SpecLevel {
  const o = (options.__typename ? options : cache["SpecLevel"] = {}) as SpecLevel;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SpecLevel";
  o.id = options.id ?? nextFactoryId("SpecLevel");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.priceInCents = options.priceInCents ?? 0;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.elevation = maybeNewElevation(options.elevation, cache, options.hasOwnProperty("elevation"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  o.optionTos = (options.optionTos ?? []).map((i) =>
    maybeNewOptionToSpecLevel(i, cache, options.hasOwnProperty("optionTos"))
  );
  o.styles = (options.styles ?? []).map((i) => maybeNewSpecLevelStyle(i, cache, options.hasOwnProperty("styles")));
  return o;
}

factories["SpecLevel"] = newSpecLevel;

function maybeNewSpecLevel(
  value: SpecLevelOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SpecLevel {
  if (value === undefined) {
    return isSet ? undefined : cache["SpecLevel"] || newSpecLevel({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSpecLevel(value, cache);
  }
}

function maybeNewOrNullSpecLevel(
  value: SpecLevelOptions | undefined | null,
  cache: Record<string, any>,
): SpecLevel | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSpecLevel(value, cache);
  }
}
export interface SaveSpecLevelResultOptions {
  __typename?: "SaveSpecLevelResult";
  specLevel?: SpecLevelOptions;
}

export function newSaveSpecLevelResult(
  options: SaveSpecLevelResultOptions = {},
  cache: Record<string, any> = {},
): SaveSpecLevelResult {
  const o = (options.__typename ? options : cache["SaveSpecLevelResult"] = {}) as SaveSpecLevelResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSpecLevelResult";
  o.specLevel = maybeNewSpecLevel(options.specLevel, cache, options.hasOwnProperty("specLevel"));
  return o;
}

factories["SaveSpecLevelResult"] = newSaveSpecLevelResult;

function maybeNewSaveSpecLevelResult(
  value: SaveSpecLevelResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveSpecLevelResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveSpecLevelResult"] || newSaveSpecLevelResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveSpecLevelResult(value, cache);
  }
}

function maybeNewOrNullSaveSpecLevelResult(
  value: SaveSpecLevelResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveSpecLevelResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveSpecLevelResult(value, cache);
  }
}
export interface SpecLevelStyleOptions {
  __typename?: "SpecLevelStyle";
  id?: SpecLevelStyle["id"];
  airtableId?: SpecLevelStyle["airtableId"];
  name?: SpecLevelStyle["name"];
  priceInCents?: SpecLevelStyle["priceInCents"];
  image?: SpecLevelStyle["image"];
  createdAt?: SpecLevelStyle["createdAt"];
  updatedAt?: SpecLevelStyle["updatedAt"];
  specLevel?: SpecLevelOptions;
  configurations?: Array<ConfigurationOptions>;
  interiorImages?: Array<InteriorImageOptions>;
}

export function newSpecLevelStyle(
  options: SpecLevelStyleOptions = {},
  cache: Record<string, any> = {},
): SpecLevelStyle {
  const o = (options.__typename ? options : cache["SpecLevelStyle"] = {}) as SpecLevelStyle;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SpecLevelStyle";
  o.id = options.id ?? nextFactoryId("SpecLevelStyle");
  o.airtableId = options.airtableId ?? "airtableId";
  o.name = options.name ?? "name";
  o.priceInCents = options.priceInCents ?? 0;
  o.image = options.image ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.specLevel = maybeNewSpecLevel(options.specLevel, cache, options.hasOwnProperty("specLevel"));
  o.configurations = (options.configurations ?? []).map((i) =>
    maybeNewConfiguration(i, cache, options.hasOwnProperty("configurations"))
  );
  o.interiorImages = (options.interiorImages ?? []).map((i) =>
    maybeNewInteriorImage(i, cache, options.hasOwnProperty("interiorImages"))
  );
  return o;
}

factories["SpecLevelStyle"] = newSpecLevelStyle;

function maybeNewSpecLevelStyle(
  value: SpecLevelStyleOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SpecLevelStyle {
  if (value === undefined) {
    return isSet ? undefined : cache["SpecLevelStyle"] || newSpecLevelStyle({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSpecLevelStyle(value, cache);
  }
}

function maybeNewOrNullSpecLevelStyle(
  value: SpecLevelStyleOptions | undefined | null,
  cache: Record<string, any>,
): SpecLevelStyle | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSpecLevelStyle(value, cache);
  }
}
export interface SaveSpecLevelStyleResultOptions {
  __typename?: "SaveSpecLevelStyleResult";
  specLevelStyle?: SpecLevelStyleOptions;
}

export function newSaveSpecLevelStyleResult(
  options: SaveSpecLevelStyleResultOptions = {},
  cache: Record<string, any> = {},
): SaveSpecLevelStyleResult {
  const o = (options.__typename ? options : cache["SaveSpecLevelStyleResult"] = {}) as SaveSpecLevelStyleResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveSpecLevelStyleResult";
  o.specLevelStyle = maybeNewSpecLevelStyle(options.specLevelStyle, cache, options.hasOwnProperty("specLevelStyle"));
  return o;
}

factories["SaveSpecLevelStyleResult"] = newSaveSpecLevelStyleResult;

function maybeNewSaveSpecLevelStyleResult(
  value: SaveSpecLevelStyleResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveSpecLevelStyleResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveSpecLevelStyleResult"] || newSaveSpecLevelStyleResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveSpecLevelStyleResult(value, cache);
  }
}

function maybeNewOrNullSaveSpecLevelStyleResult(
  value: SaveSpecLevelStyleResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveSpecLevelStyleResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveSpecLevelStyleResult(value, cache);
  }
}
export interface UserOptions {
  __typename?: "User";
  id?: User["id"];
  email?: User["email"];
  deactivatedAt?: User["deactivatedAt"];
  gsuiteEmailAlias?: User["gsuiteEmailAlias"];
  createdAt?: User["createdAt"];
  updatedAt?: User["updatedAt"];
  type?: UserTypeDetailOptions | UserType;
  homeowner?: HomeownerOptions | null;
  internalUser?: InternalUserOptions | null;
  isActive?: User["isActive"];
}

export function newUser(options: UserOptions = {}, cache: Record<string, any> = {}): User {
  const o = (options.__typename ? options : cache["User"] = {}) as User;
  (cache.all ??= new Set()).add(o);
  o.__typename = "User";
  o.id = options.id ?? null;
  o.email = options.email ?? "email";
  o.deactivatedAt = options.deactivatedAt ?? null;
  o.gsuiteEmailAlias = options.gsuiteEmailAlias ?? null;
  o.createdAt = options.createdAt ?? newDateTime();
  o.updatedAt = options.updatedAt ?? newDateTime();
  o.type = enumOrDetailOfUserType(options.type);
  o.homeowner = maybeNewOrNullHomeowner(options.homeowner, cache);
  o.internalUser = maybeNewOrNullInternalUser(options.internalUser, cache);
  o.isActive = options.isActive ?? null;
  return o;
}

factories["User"] = newUser;

function maybeNewUser(value: UserOptions | undefined, cache: Record<string, any>, isSet: boolean = false): User {
  if (value === undefined) {
    return isSet ? undefined : cache["User"] || newUser({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUser(value, cache);
  }
}

function maybeNewOrNullUser(value: UserOptions | undefined | null, cache: Record<string, any>): User | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newUser(value, cache);
  }
}
export interface SaveUserResultOptions {
  __typename?: "SaveUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newSaveUserResult(
  options: SaveUserResultOptions = {},
  cache: Record<string, any> = {},
): SaveUserResult {
  const o = (options.__typename ? options : cache["SaveUserResult"] = {}) as SaveUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "SaveUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNewUserError(i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["SaveUserResult"] = newSaveUserResult;

function maybeNewSaveUserResult(
  value: SaveUserResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): SaveUserResult {
  if (value === undefined) {
    return isSet ? undefined : cache["SaveUserResult"] || newSaveUserResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveUserResult(value, cache);
  }
}

function maybeNewOrNullSaveUserResult(
  value: SaveUserResultOptions | undefined | null,
  cache: Record<string, any>,
): SaveUserResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newSaveUserResult(value, cache);
  }
}
export interface DeactivateUserResultOptions {
  __typename?: "DeactivateUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newDeactivateUserResult(
  options: DeactivateUserResultOptions = {},
  cache: Record<string, any> = {},
): DeactivateUserResult {
  const o = (options.__typename ? options : cache["DeactivateUserResult"] = {}) as DeactivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "DeactivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNewUserError(i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["DeactivateUserResult"] = newDeactivateUserResult;

function maybeNewDeactivateUserResult(
  value: DeactivateUserResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): DeactivateUserResult {
  if (value === undefined) {
    return isSet ? undefined : cache["DeactivateUserResult"] || newDeactivateUserResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newDeactivateUserResult(value, cache);
  }
}

function maybeNewOrNullDeactivateUserResult(
  value: DeactivateUserResultOptions | undefined | null,
  cache: Record<string, any>,
): DeactivateUserResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newDeactivateUserResult(value, cache);
  }
}
export interface ActivateUserResultOptions {
  __typename?: "ActivateUserResult";
  userErrors?: Array<UserErrorOptions>;
}

export function newActivateUserResult(
  options: ActivateUserResultOptions = {},
  cache: Record<string, any> = {},
): ActivateUserResult {
  const o = (options.__typename ? options : cache["ActivateUserResult"] = {}) as ActivateUserResult;
  (cache.all ??= new Set()).add(o);
  o.__typename = "ActivateUserResult";
  o.userErrors = (options.userErrors ?? []).map((i) =>
    maybeNewUserError(i, cache, options.hasOwnProperty("userErrors"))
  );
  return o;
}

factories["ActivateUserResult"] = newActivateUserResult;

function maybeNewActivateUserResult(
  value: ActivateUserResultOptions | undefined,
  cache: Record<string, any>,
  isSet: boolean = false,
): ActivateUserResult {
  if (value === undefined) {
    return isSet ? undefined : cache["ActivateUserResult"] || newActivateUserResult({}, cache);
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newActivateUserResult(value, cache);
  }
}

function maybeNewOrNullActivateUserResult(
  value: ActivateUserResultOptions | undefined | null,
  cache: Record<string, any>,
): ActivateUserResult | null {
  if (!value) {
    return null;
  } else if (value.__typename) {
    return cache.all?.has(value) ? value : factories[value.__typename](value, cache);
  } else {
    return newActivateUserResult(value, cache);
  }
}
const enumDetailNameOfUserType = {
  ANONYMOUS: "Anonymous",
  SYSTEM: "System",
  INTERNAL: "Internal",
  HOMEOWNER: "Homeowner",
};

function enumOrDetailOfUserType(enumOrDetail: UserTypeDetailOptions | UserType | undefined): UserTypeDetail {
  if (enumOrDetail === undefined) {
    return newUserTypeDetail();
  } else if (typeof enumOrDetail === "object" && "code" in enumOrDetail) {
    return {
      __typename: "UserTypeDetail",
      code: enumOrDetail.code!,
      name: enumDetailNameOfUserType[enumOrDetail.code!],
      ...enumOrDetail,
    } as UserTypeDetail;
  } else {
    return newUserTypeDetail({
      code: enumOrDetail as UserType,
      name: enumDetailNameOfUserType[enumOrDetail as UserType],
    });
  }
}

function enumOrDetailOrNullOfUserType(
  enumOrDetail: UserTypeDetailOptions | UserType | undefined | null,
): UserTypeDetail | null {
  if (enumOrDetail === null) {
    return null;
  }
  return enumOrDetailOfUserType(enumOrDetail);
}

const taggedIds: Record<string, string> = {};
let nextFactoryIds: Record<string, number> = {};

export function resetFactoryIds() {
  nextFactoryIds = {};
}

function nextFactoryId(objectName: string): string {
  const nextId = nextFactoryIds[objectName] || 1;
  nextFactoryIds[objectName] = nextId + 1;
  const tag = taggedIds[objectName] ?? objectName.replace(/[a-z]/g, "").toLowerCase();
  return tag + ":" + nextId;
}

export const possibleTypes = {} as const;

export const enumTypePolicies = { LotTypeDetail: { keyFields: ["code"] }, UserTypeDetail: { keyFields: ["code"] } };

interface PlansDataOptions {
  plans?: PlanOptions[];
}

export function newPlansData(data: PlansDataOptions) {
  return { __typename: "Query" as const, plans: data["plans"]?.map((d) => newPlan(d)) || [] };
}

export function newPlansResponse(data: PlansDataOptions | Error): MockedResponse<PlansQueryVariables, PlansQuery> {
  return {
    request: { query: PlansDocument },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newPlansData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface SpecLevelsDataOptions {
  specLevels?: SpecLevelOptions[];
}

export function newSpecLevelsData(data: SpecLevelsDataOptions) {
  return { __typename: "Query" as const, specLevels: data["specLevels"]?.map((d) => newSpecLevel(d)) || [] };
}

export function newSpecLevelsResponse(
  variables: SpecLevelsQueryVariables,
  data: SpecLevelsDataOptions | Error,
): MockedResponse<SpecLevelsQueryVariables, SpecLevelsQuery> {
  return {
    request: { query: SpecLevelsDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newSpecLevelsData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveConfigurationDataOptions {
  saveConfiguration?: SaveConfigurationResultOptions;
}

export function newSaveConfigurationData(data: SaveConfigurationDataOptions) {
  return {
    __typename: "Mutation" as const,
    saveConfiguration: maybeNewSaveConfigurationResult(data["saveConfiguration"] || undefined, {}),
  };
}

export function newSaveConfigurationResponse(
  variables: SaveConfigurationMutationVariables,
  data: SaveConfigurationDataOptions | Error,
): MockedResponse<SaveConfigurationMutationVariables, SaveConfigurationMutation> {
  return {
    request: { query: SaveConfigurationDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newSaveConfigurationData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface SaveConfigurationOptionsDataOptions {
  saveConfigurationToOptions?: SaveConfigurationToOptionsResultOptions;
}

export function newSaveConfigurationOptionsData(data: SaveConfigurationOptionsDataOptions) {
  return {
    __typename: "Mutation" as const,
    saveConfigurationToOptions: maybeNewSaveConfigurationToOptionsResult(
      data["saveConfigurationToOptions"] || undefined,
      {},
    ),
  };
}

export function newSaveConfigurationOptionsResponse(
  variables: SaveConfigurationOptionsMutationVariables,
  data: SaveConfigurationOptionsDataOptions | Error,
): MockedResponse<SaveConfigurationOptionsMutationVariables, SaveConfigurationOptionsMutation> {
  return {
    request: { query: SaveConfigurationOptionsDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newSaveConfigurationOptionsData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface ConfigurationDataOptions {
  configuration?: ConfigurationOptions;
}

export function newConfigurationData(data: ConfigurationDataOptions) {
  return { __typename: "Query" as const, configuration: maybeNewConfiguration(data["configuration"] || undefined, {}) };
}

export function newConfigurationResponse(
  variables: ConfigurationQueryVariables,
  data: ConfigurationDataOptions | Error,
): MockedResponse<ConfigurationQueryVariables, ConfigurationQuery> {
  return {
    request: { query: ConfigurationDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newConfigurationData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface PropertiesDataOptions {
  properties?: PropertyOptions[];
}

export function newPropertiesData(data: PropertiesDataOptions) {
  return { __typename: "Query" as const, properties: data["properties"]?.map((d) => newProperty(d)) || [] };
}

export function newPropertiesResponse(
  variables: PropertiesQueryVariables,
  data: PropertiesDataOptions | Error,
): MockedResponse<PropertiesQueryVariables, PropertiesQuery> {
  return {
    request: { query: PropertiesDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newPropertiesData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface PropertyDataOptions {
  property?: PropertyOptions | null;
}

export function newPropertyData(data: PropertyDataOptions) {
  return { __typename: "Query" as const, property: maybeNewOrNullProperty(data["property"] || undefined, {}) };
}

export function newPropertyResponse(
  variables: PropertyQueryVariables,
  data: PropertyDataOptions | Error,
): MockedResponse<PropertyQueryVariables, PropertyQuery> {
  return {
    request: { query: PropertyDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newPropertyData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}
interface OptionsDataOptions {
  options?: OptionOptions[];
}

export function newOptionsData(data: OptionsDataOptions) {
  return { __typename: "Query" as const, options: data["options"]?.map((d) => newOption(d)) || [] };
}

export function newOptionsResponse(
  variables: OptionsQueryVariables,
  data: OptionsDataOptions | Error,
): MockedResponse<OptionsQueryVariables, OptionsQuery> {
  return {
    request: { query: OptionsDocument, variables },
    // TODO Remove the any by having interfaces have a __typename that pacifies mutation type unions
    result: { data: data instanceof Error ? undefined : newOptionsData(data) as any },
    error: data instanceof Error ? data : undefined,
  };
}

  export type MockedResponse<V, Q> = {
    request: {
      query: any;
      variables?: V;
    };
    result: {
      data?: Q;
    };
    error?: Error;
    // Note this only works if using Homebound's better-apollo-mocked-provider
    requestedCount?: number;
  };

import { dateTimeTypePolicy } from "src/utils/dates";

export const scalarTypePolicies = {
  Asset: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Configuration: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, completedDate: dateTimeTypePolicy },
  },
  ConfigurationToOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Elevation: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ElevationStyle: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  ExteriorImage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Floor: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  HelloWorld: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Homeowner: {
    fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy, lastActive: dateTimeTypePolicy },
  },
  InteriorImage: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  InternalUser: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Option: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  OptionToOption: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  OptionToSpecLevel: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  Plan: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  History: { fields: { recordedAt: dateTimeTypePolicy } },
  SpecLevel: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  SpecLevelStyle: { fields: { createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
  User: { fields: { deactivatedAt: dateTimeTypePolicy, createdAt: dateTimeTypePolicy, updatedAt: dateTimeTypePolicy } },
};

import { baseOnError } from "src/utils/baseOnError";
(defaultOptions as any).onError = (e: any) => { baseOnError(e); };